var mi = Object.defineProperty;
var Si = (e, t, n) => t in e ? mi(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var N = (e, t, n) => Si(e, typeof t != "symbol" ? t + "" : t, n);
import Ei from "diagram-js";
import { queryAll as bi, query as ie, delegate as We, classes as Z, closest as wi, event as q, attr as Re, assignStyle as $e, remove as wt, clear as Yn, domify as oe } from "min-dom";
import { create as F, attr as M, append as G, remove as qn, innerSVG as on } from "tiny-svg";
import { isObject as an } from "lodash";
const Le = Object.prototype.toString, xi = Object.prototype.hasOwnProperty;
function Zn(e) {
  return e === void 0;
}
function W(e) {
  return e !== void 0;
}
function Ci(e) {
  return e == null;
}
function D(e) {
  return Le.call(e) === "[object Array]";
}
function he(e) {
  return Le.call(e) === "[object Object]";
}
function ue(e) {
  return Le.call(e) === "[object Number]";
}
function At(e) {
  const t = Le.call(e);
  return t === "[object Function]" || t === "[object AsyncFunction]" || t === "[object GeneratorFunction]" || t === "[object AsyncGeneratorFunction]" || t === "[object Proxy]";
}
function xt(e) {
  return Le.call(e) === "[object String]";
}
function Mt(e, t) {
  return !Ci(e) && xi.call(e, t);
}
function Xe(e, t) {
  const n = Jn(t);
  let r;
  return v(e, function(i, o) {
    if (n(i, o))
      return r = i, !1;
  }), r;
}
function Ce(e, t) {
  const n = Jn(t);
  let r = [];
  return v(e, function(i, o) {
    n(i, o) && r.push(i);
  }), r;
}
function v(e, t) {
  let n, r;
  if (Zn(e))
    return;
  const i = D(e) ? Ai : Li;
  for (let o in e)
    if (Mt(e, o) && (n = e[o], r = t(n, i(o)), r === !1))
      return n;
}
function Ct(e, t, n) {
  return v(e, function(r, i) {
    n = t(n, r, i);
  }), n;
}
function Ti(e, t) {
  return !!Ct(e, function(n, r, i) {
    return n && t(r, i);
  }, !0);
}
function ki(e, t) {
  return !!Xe(e, t);
}
function ae(e, t) {
  let n = [];
  return v(e, function(r, i) {
    n.push(t(r, i));
  }), n;
}
function Oi(e) {
  return ae(e, (t) => t);
}
function Xn(e, t, n = {}) {
  return t = Pt(t), v(e, function(r) {
    let i = t(r) || "_", o = n[i];
    o || (o = n[i] = []), o.push(r);
  }), n;
}
function Ri(e, ...t) {
  e = Pt(e);
  let n = {};
  return v(t, (i) => Xn(i, e, n)), ae(n, function(i, o) {
    return i[0];
  });
}
function $i(e, t) {
  t = Pt(t);
  let n = [];
  return v(e, function(r, i) {
    let o = t(r, i), a = {
      d: o,
      v: r
    };
    for (var s = 0; s < n.length; s++) {
      let { d: c } = n[s];
      if (o < c) {
        n.splice(s, 0, a);
        return;
      }
    }
    n.push(a);
  }), ae(n, (r) => r.v);
}
function sn(e) {
  return function(t) {
    return Ti(e, function(n, r) {
      return t[r] === n;
    });
  };
}
function Pt(e) {
  return At(e) ? e : (t) => t[e];
}
function Jn(e) {
  return At(e) ? e : (t) => t === e;
}
function Li(e) {
  return e;
}
function Ai(e) {
  return Number(e);
}
function Mi(e, t) {
  return e.bind(t);
}
function R(e, ...t) {
  return Object.assign(e, ...t);
}
function Tt(e, t) {
  let n = {}, r = Object(e);
  return v(t, function(i) {
    i in r && (n[i] = e[i]);
  }), n;
}
function Pi(e, t) {
  let n = {}, r = Object(e);
  return v(r, function(i, o) {
    t.indexOf(o) === -1 && (n[o] = i);
  }), n;
}
function $(e, t) {
  this._handlerMap = {}, this._stack = [], this._stackIdx = -1, this._currentExecution = {
    actions: [],
    dirty: [],
    trigger: null
  }, this._injector = t, this._eventBus = e, this._uid = 1, e.on([
    "diagram.destroy",
    "diagram.clear"
  ], function() {
    this.clear(!1);
  }, this);
}
$.$inject = ["eventBus", "injector"];
$.prototype.execute = function(e, t) {
  if (!e)
    throw new Error("command required");
  this._currentExecution.trigger = "execute";
  const n = { command: e, context: t };
  this._pushAction(n), this._internalExecute(n), this._popAction();
};
$.prototype.canExecute = function(e, t) {
  const n = { command: e, context: t }, r = this._getHandler(e);
  let i = this._fire(e, "canExecute", n);
  if (i === void 0) {
    if (!r)
      return !1;
    r.canExecute && (i = r.canExecute(t));
  }
  return i;
};
$.prototype.clear = function(e) {
  this._stack.length = 0, this._stackIdx = -1, e !== !1 && this._fire("changed", { trigger: "clear" });
};
$.prototype.undo = function() {
  let e = this._getUndoAction(), t;
  if (e) {
    for (this._currentExecution.trigger = "undo", this._pushAction(e); e && (this._internalUndo(e), t = this._getUndoAction(), !(!t || t.id !== e.id)); )
      e = t;
    this._popAction();
  }
};
$.prototype.redo = function() {
  let e = this._getRedoAction(), t;
  if (e) {
    for (this._currentExecution.trigger = "redo", this._pushAction(e); e && (this._internalExecute(e, !0), t = this._getRedoAction(), !(!t || t.id !== e.id)); )
      e = t;
    this._popAction();
  }
};
$.prototype.register = function(e, t) {
  this._setHandler(e, t);
};
$.prototype.registerHandler = function(e, t) {
  if (!e || !t)
    throw new Error("command and handlerCls must be defined");
  const n = this._injector.instantiate(t);
  this.register(e, n);
};
$.prototype.canUndo = function() {
  return !!this._getUndoAction();
};
$.prototype.canRedo = function() {
  return !!this._getRedoAction();
};
$.prototype._getRedoAction = function() {
  return this._stack[this._stackIdx + 1];
};
$.prototype._getUndoAction = function() {
  return this._stack[this._stackIdx];
};
$.prototype._internalUndo = function(e) {
  const t = e.command, n = e.context, r = this._getHandler(t);
  this._atomicDo(() => {
    this._fire(t, "revert", e), r.revert && this._markDirty(r.revert(n)), this._revertedAction(e), this._fire(t, "reverted", e);
  });
};
$.prototype._fire = function(e, t, n) {
  arguments.length < 3 && (n = t, t = null);
  const r = t ? [e + "." + t, t] : [e];
  let i;
  n = this._eventBus.createEvent(n);
  for (const o of r)
    if (i = this._eventBus.fire("commandStack." + o, n), n.cancelBubble)
      break;
  return i;
};
$.prototype._createId = function() {
  return this._uid++;
};
$.prototype._atomicDo = function(e) {
  const t = this._currentExecution;
  t.atomic = !0;
  try {
    e();
  } finally {
    t.atomic = !1;
  }
};
$.prototype._internalExecute = function(e, t) {
  const n = e.command, r = e.context, i = this._getHandler(n);
  if (!i)
    throw new Error("no command handler registered for <" + n + ">");
  this._pushAction(e), t || (this._fire(n, "preExecute", e), i.preExecute && i.preExecute(r), this._fire(n, "preExecuted", e)), this._atomicDo(() => {
    this._fire(n, "execute", e), i.execute && this._markDirty(i.execute(r)), this._executedAction(e, t), this._fire(n, "executed", e);
  }), t || (this._fire(n, "postExecute", e), i.postExecute && i.postExecute(r), this._fire(n, "postExecuted", e)), this._popAction();
};
$.prototype._pushAction = function(e) {
  const t = this._currentExecution, n = t.actions, r = n[0];
  if (t.atomic)
    throw new Error("illegal invocation in <execute> or <revert> phase (action: " + e.command + ")");
  e.id || (e.id = r && r.id || this._createId()), n.push(e);
};
$.prototype._popAction = function() {
  const e = this._currentExecution, t = e.trigger, n = e.actions, r = e.dirty;
  n.pop(), n.length || (this._eventBus.fire("elements.changed", { elements: Ri("id", r.reverse()) }), r.length = 0, this._fire("changed", { trigger: t }), e.trigger = null);
};
$.prototype._markDirty = function(e) {
  const t = this._currentExecution;
  e && (e = D(e) ? e : [e], t.dirty = t.dirty.concat(e));
};
$.prototype._executedAction = function(e, t) {
  const n = ++this._stackIdx;
  t || this._stack.splice(n, this._stack.length, e);
};
$.prototype._revertedAction = function(e) {
  this._stackIdx--;
};
$.prototype._getHandler = function(e) {
  return this._handlerMap[e];
};
$.prototype._setHandler = function(e, t) {
  if (!e || !t)
    throw new Error("command and handler required");
  if (this._handlerMap[e])
    throw new Error("overriding handler for command <" + e + ">");
  this._handlerMap[e] = t;
};
const ji = {
  commandStack: ["type", $]
};
function Ii(e) {
  return Ce(e, function(t) {
    return !Xe(e, function(n) {
      return n !== t && Qn(t, n);
    });
  });
}
function Qn(e, t) {
  if (t) {
    if (e === t)
      return t;
    if (e.parent)
      return Qn(e.parent, t);
  }
}
function er(e, t, n) {
  n = n || 0, D(e) || (e = [e]), v(e, function(r, i) {
    var o = t(r, i, n);
    D(o) && o.length && er(o, t, n + 1);
  });
}
function Hi(e, t, n) {
  Zn(t) && (t = !0), he(t) && (n = t, t = !0), n = n || {};
  var r = Ee(n.allShapes), i = Ee(n.allConnections), o = Ee(n.enclosedElements), a = Ee(n.enclosedConnections), s = Ee(
    n.topLevel,
    t && Xn(e, function(l) {
      return l.id;
    })
  );
  function c(l) {
    s[l.source.id] && s[l.target.id] && (s[l.id] = [l]), r[l.source.id] && r[l.target.id] && (a[l.id] = o[l.id] = l), i[l.id] = l;
  }
  function u(l) {
    if (o[l.id] = l, l.waypoints)
      a[l.id] = i[l.id] = l;
    else
      return r[l.id] = l, v(l.incoming, c), v(l.outgoing, c), l.children;
  }
  return er(e, u), {
    allShapes: r,
    allConnections: i,
    topLevel: s,
    enclosedConnections: a,
    enclosedElements: o
  };
}
function Te(e, t) {
  t = !!t, D(e) || (e = [e]);
  var n, r, i, o;
  return v(e, function(a) {
    var s = a;
    a.waypoints && !t && (s = Te(a.waypoints, !0));
    var c = s.x, u = s.y, l = s.height || 0, h = s.width || 0;
    (c < n || n === void 0) && (n = c), (u < r || r === void 0) && (r = u), (c + h > i || i === void 0) && (i = c + h), (u + l > o || o === void 0) && (o = u + l);
  }), {
    x: n,
    y: r,
    height: o - r,
    width: i - n
  };
}
function Ni(e) {
  return "waypoints" in e ? "connection" : "x" in e ? "shape" : "root";
}
function Ee(e, t) {
  return R({}, e || {}, t || {});
}
function tr(e, t, n, r) {
  e.on("element.changed", function(i) {
    var o = i.element;
    (o.parent || o === t.getRootElement()) && (i.gfx = n.getGraphics(o)), i.gfx && e.fire(Ni(o) + ".changed", i);
  }), e.on("elements.changed", function(i) {
    var o = i.elements;
    o.forEach(function(a) {
      e.fire("element.changed", { element: a });
    }), r.updateContainments(o);
  }), e.on("shape.changed", function(i) {
    r.update("shape", i.element, i.gfx);
  }), e.on("connection.changed", function(i) {
    r.update("connection", i.element, i.gfx);
  });
}
tr.$inject = [
  "eventBus",
  "canvas",
  "elementRegistry",
  "graphicsFactory"
];
const Di = {
  __init__: ["changeSupport"],
  changeSupport: ["type", tr]
};
function nr(e) {
  return e.originalEvent || e.srcEvent;
}
function cn(e) {
  return e.pointers && e.pointers.length && (e = e.pointers[0]), e.touches && e.touches.length && (e = e.touches[0]), e ? {
    x: e.clientX,
    y: e.clientY
  } : null;
}
function Bi() {
  return /mac/i.test(navigator.platform);
}
function rr(e, t) {
  return (nr(e) || e).button === t;
}
function Je(e) {
  return rr(e, 0);
}
function Fi(e) {
  return rr(e, 1);
}
function Ui(e) {
  var t = nr(e) || e;
  return Je(e) && t.shiftKey;
}
function zi(e) {
  return e.flat().join(",").replace(/,?([A-Za-z]),?/g, "$1");
}
function Gi(e) {
  return ["M", e.x, e.y];
}
function mt(e) {
  return ["L", e.x, e.y];
}
function Vi(e, t, n) {
  return ["C", e.x, e.y, t.x, t.y, n.x, n.y];
}
function Wi(e, t) {
  const n = e.length, r = [Gi(e[0])];
  for (let i = 1; i < n; i++) {
    const o = e[i - 1], a = e[i], s = e[i + 1];
    if (!s || !t) {
      r.push(mt(a));
      continue;
    }
    const c = Math.min(
      t,
      kt(a.x - o.x, a.y - o.y),
      kt(s.x - a.x, s.y - a.y)
    );
    if (!c) {
      r.push(mt(a));
      continue;
    }
    const u = Ue(a, o, c), l = Ue(a, o, c * 0.5), h = Ue(a, s, c), d = Ue(a, s, c * 0.5);
    r.push(mt(u)), r.push(Vi(l, d, h));
  }
  return r;
}
function Ue(e, t, n) {
  const r = t.x - e.x, i = t.y - e.y, o = kt(r, i), a = n / o;
  return {
    x: e.x + r * a,
    y: e.y + i * a
  };
}
function kt(e, t) {
  return Math.sqrt(Math.pow(e, 2) + Math.pow(t, 2));
}
function ir(e, t, n) {
  ue(t) && (n = t, t = null), t || (t = {});
  const r = F("path", t);
  return ue(n) && (r.dataset.cornerRadius = String(n)), or(r, e);
}
function or(e, t) {
  const n = parseInt(e.dataset.cornerRadius, 10) || 0;
  return M(e, {
    d: zi(Wi(t, n))
  }), e;
}
function Ki(e) {
  return !0;
}
function ze(e) {
  return Je(e) || Fi(e);
}
var ln = 500;
function ar(e, t, n) {
  var r = this;
  function i(f, g, _) {
    if (!s(f, g)) {
      var L, B, Fe;
      _ ? B = t.getGraphics(_) : (L = g.delegateTarget || g.target, L && (B = L, _ = t.get(B))), !(!B || !_) && (Fe = e.fire(f, {
        element: _,
        gfx: B,
        originalEvent: g
      }), Fe === !1 && (g.stopPropagation(), g.preventDefault()));
    }
  }
  var o = {};
  function a(f) {
    return o[f];
  }
  function s(f, g) {
    var _ = u[f] || Je;
    return !_(g);
  }
  var c = {
    click: "element.click",
    contextmenu: "element.contextmenu",
    dblclick: "element.dblclick",
    mousedown: "element.mousedown",
    mousemove: "element.mousemove",
    mouseover: "element.hover",
    mouseout: "element.out",
    mouseup: "element.mouseup"
  }, u = {
    "element.contextmenu": Ki,
    "element.mousedown": ze,
    "element.mouseup": ze,
    "element.click": ze,
    "element.dblclick": ze
  };
  function l(f, g, _) {
    var L = c[f];
    if (!L)
      throw new Error("unmapped DOM event name <" + f + ">");
    return i(L, g, _);
  }
  var h = "svg, .djs-element";
  function d(f, g, _, L) {
    var B = o[_] = function(Fe) {
      i(_, Fe);
    };
    L && (u[_] = L), B.$delegate = We.bind(f, h, g, B);
  }
  function S(f, g, _) {
    var L = a(_);
    L && We.unbind(f, g, L.$delegate);
  }
  function p(f) {
    v(c, function(g, _) {
      d(f, _, g);
    });
  }
  function b(f) {
    v(c, function(g, _) {
      S(f, _, g);
    });
  }
  e.on("canvas.destroy", function(f) {
    b(f.svg);
  }), e.on("canvas.init", function(f) {
    p(f.svg);
  }), e.on(["shape.added", "connection.added"], function(f) {
    var g = f.element, _ = f.gfx;
    e.fire("interactionEvents.createHit", { element: g, gfx: _ });
  }), e.on([
    "shape.changed",
    "connection.changed"
  ], ln, function(f) {
    var g = f.element, _ = f.gfx;
    e.fire("interactionEvents.updateHit", { element: g, gfx: _ });
  }), e.on("interactionEvents.createHit", ln, function(f) {
    var g = f.element, _ = f.gfx;
    r.createDefaultHit(g, _);
  }), e.on("interactionEvents.updateHit", function(f) {
    var g = f.element, _ = f.gfx;
    r.updateDefaultHit(g, _);
  });
  var y = x("djs-hit djs-hit-stroke"), T = x("djs-hit djs-hit-click-stroke"), w = x("djs-hit djs-hit-all"), A = x("djs-hit djs-hit-no-move"), E = {
    all: w,
    "click-stroke": T,
    stroke: y,
    "no-move": A
  };
  function x(f, g) {
    return g = R({
      stroke: "white",
      strokeWidth: 15
    }, g || {}), n.cls(f, ["no-fill", "no-border"], g);
  }
  function U(f, g) {
    var _ = E[g];
    if (!_)
      throw new Error("invalid hit type <" + g + ">");
    return M(f, _), f;
  }
  function J(f, g) {
    G(f, g);
  }
  this.removeHits = function(f) {
    var g = bi(".djs-hit", f);
    v(g, qn);
  }, this.createDefaultHit = function(f, g) {
    var _ = f.waypoints, L = f.isFrame, B;
    return _ ? this.createWaypointsHit(g, _) : (B = L ? "stroke" : "all", this.createBoxHit(g, B, {
      width: f.width,
      height: f.height
    }));
  }, this.createWaypointsHit = function(f, g) {
    var _ = ir(g);
    return U(_, "stroke"), J(f, _), _;
  }, this.createBoxHit = function(f, g, _) {
    _ = R({
      x: 0,
      y: 0
    }, _);
    var L = F("rect");
    return U(L, g), M(L, _), J(f, L), L;
  }, this.updateDefaultHit = function(f, g) {
    var _ = ie(".djs-hit", g);
    if (_)
      return f.waypoints ? or(_, f.waypoints) : M(_, {
        width: f.width,
        height: f.height
      }), _;
  }, this.fire = i, this.triggerMouseEvent = l, this.mouseHandler = a, this.registerEvent = d, this.unregisterEvent = S;
}
ar.$inject = [
  "eventBus",
  "elementRegistry",
  "styles"
];
const Yi = {
  __init__: ["interactionEvents"],
  interactionEvents: ["type", ar]
};
function de(e, t) {
  this._eventBus = e, this._canvas = t, this._selectedElements = [];
  var n = this;
  e.on(["shape.remove", "connection.remove"], function(r) {
    var i = r.element;
    n.deselect(i);
  }), e.on(["diagram.clear", "root.set"], function(r) {
    n.select(null);
  });
}
de.$inject = ["eventBus", "canvas"];
de.prototype.deselect = function(e) {
  var t = this._selectedElements, n = t.indexOf(e);
  if (n !== -1) {
    var r = t.slice();
    t.splice(n, 1), this._eventBus.fire("selection.changed", { oldSelection: r, newSelection: t });
  }
};
de.prototype.get = function() {
  return this._selectedElements;
};
de.prototype.isSelected = function(e) {
  return this._selectedElements.indexOf(e) !== -1;
};
de.prototype.select = function(e, t) {
  var n = this._selectedElements, r = n.slice();
  D(e) || (e = e ? [e] : []);
  var i = this._canvas, o = i.getRootElement();
  e = e.filter(function(a) {
    var s = i.findRoot(a);
    return o === s;
  }), t ? v(e, function(a) {
    n.indexOf(a) === -1 && n.push(a);
  }) : this._selectedElements = n = e.slice(), this._eventBus.fire("selection.changed", { oldSelection: r, newSelection: n });
};
var un = "hover", hn = "selected";
function sr(e, t) {
  this._canvas = e;
  function n(i, o) {
    e.addMarker(i, o);
  }
  function r(i, o) {
    e.removeMarker(i, o);
  }
  t.on("element.hover", function(i) {
    n(i.element, un);
  }), t.on("element.out", function(i) {
    r(i.element, un);
  }), t.on("selection.changed", function(i) {
    function o(u) {
      r(u, hn);
    }
    function a(u) {
      n(u, hn);
    }
    var s = i.oldSelection, c = i.newSelection;
    v(s, function(u) {
      c.indexOf(u) === -1 && o(u);
    }), v(c, function(u) {
      s.indexOf(u) === -1 && a(u);
    });
  });
}
sr.$inject = [
  "canvas",
  "eventBus"
];
function cr(e, t, n, r) {
  e.on("create.end", 500, function(i) {
    var o = i.context, a = o.canExecute, s = o.elements, c = o.hints || {}, u = c.autoSelect;
    if (a) {
      if (u === !1)
        return;
      D(u) ? t.select(u) : t.select(s.filter(qi));
    }
  }), e.on("connect.end", 500, function(i) {
    var o = i.context, a = o.connection;
    a && t.select(a);
  }), e.on("shape.move.end", 500, function(i) {
    var o = i.previousSelection || [], a = r.get(i.context.shape.id), s = Xe(o, function(c) {
      return a.id === c.id;
    });
    s || t.select(a);
  }), e.on("element.click", function(i) {
    if (Je(i)) {
      var o = i.element;
      o === n.getRootElement() && (o = null);
      var a = t.isSelected(o), s = t.get().length > 1, c = Ui(i);
      if (a && s)
        return c ? t.deselect(o) : t.select(o);
      a ? t.deselect(o) : t.select(o, c);
    }
  });
}
cr.$inject = [
  "eventBus",
  "selection",
  "canvas",
  "elementRegistry"
];
function qi(e) {
  return !e.hidden;
}
const jt = {
  __init__: ["selectionVisuals", "selectionBehavior"],
  __depends__: [
    Yi
  ],
  selection: ["type", de],
  selectionVisuals: ["type", sr],
  selectionBehavior: ["type", cr]
};
function It(e) {
  this._commandStack = e.get("commandStack", !1);
}
It.$inject = ["injector"];
It.prototype.allowed = function(e, t) {
  var n = !0, r = this._commandStack;
  return r && (n = r.canExecute(e, t)), n === void 0 ? !0 : n;
};
const Zi = {
  __init__: ["rules"],
  rules: ["type", It]
};
function Qe(e, t) {
  this._modeling = e, this._canvas = t;
}
Qe.$inject = ["modeling", "canvas"];
Qe.prototype.preExecute = function(e) {
  var t = this._modeling, n = e.elements, r = e.alignment;
  v(n, function(i) {
    var o = {
      x: 0,
      y: 0
    };
    W(r.left) ? o.x = r.left - i.x : W(r.right) ? o.x = r.right - i.width - i.x : W(r.center) ? o.x = r.center - Math.round(i.width / 2) - i.x : W(r.top) ? o.y = r.top - i.y : W(r.bottom) ? o.y = r.bottom - i.height - i.y : W(r.middle) && (o.y = r.middle - Math.round(i.height / 2) - i.y), t.moveElements([i], o, i.parent);
  });
};
Qe.prototype.postExecute = function(e) {
};
function et(e) {
  this._modeling = e;
}
et.$inject = ["modeling"];
et.prototype.preExecute = function(e) {
  var t = e.source;
  if (!t)
    throw new Error("source required");
  var n = e.target || t.parent, r = e.shape, i = e.hints || {};
  r = e.shape = this._modeling.createShape(
    r,
    e.position,
    n,
    { attach: i.attach }
  ), e.shape = r;
};
et.prototype.postExecute = function(e) {
  var t = e.hints || {};
  Xi(e.source, e.shape) || (t.connectionTarget === e.source ? this._modeling.connect(e.shape, e.source, e.connection) : this._modeling.connect(e.source, e.shape, e.connection));
};
function Xi(e, t) {
  return ki(e.outgoing, function(n) {
    return n.target === t;
  });
}
function tt(e, t) {
  this._canvas = e, this._layouter = t;
}
tt.$inject = ["canvas", "layouter"];
tt.prototype.execute = function(e) {
  var t = e.connection, n = e.source, r = e.target, i = e.parent, o = e.parentIndex, a = e.hints;
  if (!n || !r)
    throw new Error("source and target required");
  if (!i)
    throw new Error("parent required");
  return t.source = n, t.target = r, t.waypoints || (t.waypoints = this._layouter.layoutConnection(t, a)), this._canvas.addConnection(t, i, o), t;
};
tt.prototype.revert = function(e) {
  var t = e.connection;
  return this._canvas.removeConnection(t), t.source = null, t.target = null, t;
};
function Ke(e) {
  return he(e) && Mt(e, "waypoints");
}
function Ji(e) {
  return he(e) && Mt(e, "labelTarget");
}
var Ge = Math.round;
function Ht(e) {
  this._modeling = e;
}
Ht.$inject = [
  "modeling"
];
Ht.prototype.preExecute = function(e) {
  var t = e.elements, n = e.parent, r = e.parentIndex, i = e.position, o = e.hints, a = this._modeling;
  v(t, function(h) {
    ue(h.x) || (h.x = 0), ue(h.y) || (h.y = 0);
  });
  var s = Ce(t, function(h) {
    return !h.hidden;
  }), c = Te(s);
  v(t, function(h) {
    Ke(h) && (h.waypoints = ae(h.waypoints, function(d) {
      return {
        x: Ge(d.x - c.x - c.width / 2 + i.x),
        y: Ge(d.y - c.y - c.height / 2 + i.y)
      };
    })), R(h, {
      x: Ge(h.x - c.x - c.width / 2 + i.x),
      y: Ge(h.y - c.y - c.height / 2 + i.y)
    });
  });
  var u = Ii(t), l = {};
  v(t, function(h) {
    if (Ke(h)) {
      l[h.id] = ue(r) ? a.createConnection(
        l[h.source.id],
        l[h.target.id],
        r,
        h,
        h.parent || n,
        o
      ) : a.createConnection(
        l[h.source.id],
        l[h.target.id],
        h,
        h.parent || n,
        o
      );
      return;
    }
    var d = R({}, o);
    u.indexOf(h) === -1 && (d.autoResize = !1), Ji(h) && (d = Pi(d, ["attach"])), l[h.id] = ue(r) ? a.createShape(
      h,
      Tt(h, ["x", "y", "width", "height"]),
      h.parent || n,
      r,
      d
    ) : a.createShape(
      h,
      Tt(h, ["x", "y", "width", "height"]),
      h.parent || n,
      d
    );
  }), e.elements = Oi(l);
};
function Ae(e, t) {
  t && (e.super_ = t, e.prototype = Object.create(t.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }));
}
var dn = Math.round;
function te(e) {
  this._canvas = e;
}
te.$inject = ["canvas"];
te.prototype.execute = function(e) {
  var t = e.shape, n = e.position, r = e.parent, i = e.parentIndex;
  if (!r)
    throw new Error("parent required");
  if (!n)
    throw new Error("position required");
  return n.width !== void 0 ? R(t, n) : R(t, {
    x: n.x - dn(t.width / 2),
    y: n.y - dn(t.height / 2)
  }), this._canvas.addShape(t, r, i), t;
};
te.prototype.revert = function(e) {
  var t = e.shape;
  return this._canvas.removeShape(t), t;
};
function Me(e) {
  te.call(this, e);
}
Ae(Me, te);
Me.$inject = ["canvas"];
var Qi = te.prototype.execute;
Me.prototype.execute = function(e) {
  var t = e.shape;
  return to(t), t.labelTarget = e.labelTarget, Qi.call(this, e);
};
var eo = te.prototype.revert;
Me.prototype.revert = function(e) {
  return e.shape.labelTarget = null, eo.call(this, e);
};
function to(e) {
  ["width", "height"].forEach(function(t) {
    typeof e[t] > "u" && (e[t] = 0);
  });
}
function nt(e, t) {
  if (!e || !t)
    return -1;
  var n = e.indexOf(t);
  return n !== -1 && e.splice(n, 1), n;
}
function se(e, t, n) {
  if (!(!e || !t)) {
    typeof n != "number" && (n = -1);
    var r = e.indexOf(t);
    if (r !== -1) {
      if (r === n)
        return;
      if (n !== -1)
        e.splice(r, 1);
      else
        return;
    }
    n !== -1 ? e.splice(n, 0, t) : e.push(t);
  }
}
function lr(e, t) {
  return !e || !t ? -1 : e.indexOf(t);
}
function xe(e, t) {
  if (typeof t != "function")
    throw new Error("removeFn iterator must be a function");
  if (e) {
    for (var n; n = e[0]; )
      t(n);
    return e;
  }
}
function Pe(e, t) {
  this._canvas = e, this._modeling = t;
}
Pe.$inject = [
  "canvas",
  "modeling"
];
Pe.prototype.preExecute = function(e) {
  var t = this._modeling, n = e.connection;
  xe(n.incoming, function(r) {
    t.removeConnection(r, { nested: !0 });
  }), xe(n.outgoing, function(r) {
    t.removeConnection(r, { nested: !0 });
  });
};
Pe.prototype.execute = function(e) {
  var t = e.connection, n = t.parent;
  return e.parent = n, e.parentIndex = lr(n.children, t), e.source = t.source, e.target = t.target, this._canvas.removeConnection(t), t.source = null, t.target = null, t;
};
Pe.prototype.revert = function(e) {
  var t = e.connection, n = e.parent, r = e.parentIndex;
  return t.source = e.source, t.target = e.target, se(n.children, t, r), this._canvas.addConnection(t, n), t;
};
function Nt(e, t) {
  this._modeling = e, this._elementRegistry = t;
}
Nt.$inject = [
  "modeling",
  "elementRegistry"
];
Nt.prototype.postExecute = function(e) {
  var t = this._modeling, n = this._elementRegistry, r = e.elements;
  v(r, function(i) {
    n.get(i.id) && (i.waypoints ? t.removeConnection(i) : t.removeShape(i));
  });
};
function je(e, t) {
  this._canvas = e, this._modeling = t;
}
je.$inject = ["canvas", "modeling"];
je.prototype.preExecute = function(e) {
  var t = this._modeling, n = e.shape;
  xe(n.incoming, function(r) {
    t.removeConnection(r, { nested: !0 });
  }), xe(n.outgoing, function(r) {
    t.removeConnection(r, { nested: !0 });
  }), xe(n.children, function(r) {
    Ke(r) ? t.removeConnection(r, { nested: !0 }) : t.removeShape(r, { nested: !0 });
  });
};
je.prototype.execute = function(e) {
  var t = this._canvas, n = e.shape, r = n.parent;
  return e.oldParent = r, e.oldParentIndex = lr(r.children, n), t.removeShape(n), n;
};
je.prototype.revert = function(e) {
  var t = this._canvas, n = e.shape, r = e.oldParent, i = e.oldParentIndex;
  return se(r.children, n, i), t.addShape(n, r), n;
};
function rt(e) {
  this._modeling = e;
}
rt.$inject = ["modeling"];
var fn = {
  x: "y",
  y: "x"
};
rt.prototype.preExecute = function(e) {
  var t = this._modeling, n = e.groups, r = e.axis, i = e.dimension;
  function o(y, T) {
    y.range.min = Math.min(T[r], y.range.min), y.range.max = Math.max(T[r] + T[i], y.range.max);
  }
  function a(y) {
    return y[r] + y[i] / 2;
  }
  function s(y) {
    return y.length - 1;
  }
  function c(y) {
    return y.max - y.min;
  }
  function u(y, T) {
    var w = { y: 0 };
    w[r] = y - a(T), w[r] && (w[fn[r]] = 0, t.moveElements([T], w, T.parent));
  }
  var l = n[0], h = s(n), d = n[h], S, p, b = 0;
  v(n, function(y, T) {
    var w, A, E;
    if (y.elements.length < 2) {
      T && T !== n.length - 1 && (o(y, y.elements[0]), b += c(y.range));
      return;
    }
    w = $i(y.elements, r), A = w[0], T === h && (A = w[s(w)]), E = a(A), y.range = null, v(w, function(x) {
      if (u(E, x), y.range === null) {
        y.range = {
          min: x[r],
          max: x[r] + x[i]
        };
        return;
      }
      o(y, x);
    }), T && T !== n.length - 1 && (b += c(y.range));
  }), p = Math.abs(d.range.min - l.range.max), S = Math.round((p - b) / (n.length - 1)), !(S < n.length - 1) && v(n, function(y, T) {
    var w = {}, A;
    y === l || y === d || (A = n[T - 1], y.range.max = 0, v(y.elements, function(E, x) {
      w[fn[r]] = 0, w[r] = A.range.max - E[r] + S, y.range.min !== E[r] && (w[r] += E[r] - y.range.min), w[r] && t.moveElements([E], w, E.parent), y.range.max = Math.max(E[r] + E[i], x ? y.range.max : 0);
    }));
  });
};
rt.prototype.postExecute = function(e) {
};
function it(e, t) {
  this._layouter = e, this._canvas = t;
}
it.$inject = ["layouter", "canvas"];
it.prototype.execute = function(e) {
  var t = e.connection, n = t.waypoints;
  return R(e, {
    oldWaypoints: n
  }), t.waypoints = this._layouter.layoutConnection(t, e.hints), t;
};
it.prototype.revert = function(e) {
  var t = e.connection;
  return t.waypoints = e.oldWaypoints, t;
};
function Dt() {
}
Dt.prototype.execute = function(e) {
  var t = e.connection, n = e.delta, r = e.newParent || t.parent, i = e.newParentIndex, o = t.parent;
  return e.oldParent = o, e.oldParentIndex = nt(o.children, t), se(r.children, t, i), t.parent = r, v(t.waypoints, function(a) {
    a.x += n.x, a.y += n.y, a.original && (a.original.x += n.x, a.original.y += n.y);
  }), t;
};
Dt.prototype.revert = function(e) {
  var t = e.connection, n = t.parent, r = e.oldParent, i = e.oldParentIndex, o = e.delta;
  return nt(n.children, t), se(r.children, t, i), t.parent = r, v(t.waypoints, function(a) {
    a.x -= o.x, a.y -= o.y, a.original && (a.original.x -= o.x, a.original.y -= o.y);
  }), t;
};
function ur(e) {
  return {
    x: Math.round(e.x),
    y: Math.round(e.y)
  };
}
function pn(e) {
  return {
    top: e.y,
    right: e.x + (e.width || 0),
    bottom: e.y + (e.height || 0),
    left: e.x
  };
}
function no(e) {
  return ur({
    x: e.x + (e.width || 0) / 2,
    y: e.y + (e.height || 0) / 2
  });
}
function ro(e) {
  for (var t = e.waypoints, n = t.reduce(function(u, l, h) {
    var d = t[h - 1];
    if (d) {
      var S = u[u.length - 1], p = S && S.endLength || 0, b = oo(d, l);
      u.push({
        start: d,
        end: l,
        startLength: p,
        endLength: p + b,
        length: b
      });
    }
    return u;
  }, []), r = n.reduce(function(u, l) {
    return u + l.length;
  }, 0), i = r / 2, o = 0, a = n[o]; a.endLength < i; )
    a = n[++o];
  var s = (i - a.startLength) / a.length, c = {
    x: a.start.x + (a.end.x - a.start.x) * s,
    y: a.start.y + (a.end.y - a.start.y) * s
  };
  return c;
}
function gn(e) {
  return Ke(e) ? ro(e) : no(e);
}
function io(e, t, n) {
  n = n || 0, he(n) || (n = { x: n, y: n });
  var r = pn(e), i = pn(t), o = r.bottom + n.y <= i.top, a = r.left - n.x >= i.right, s = r.top - n.y >= i.bottom, c = r.right + n.x <= i.left, u = o ? "top" : s ? "bottom" : null, l = c ? "left" : a ? "right" : null;
  return l && u ? u + "-" + l : l || u || "intersect";
}
function oo(e, t) {
  return Math.sqrt(Math.pow(e.x - t.x, 2) + Math.pow(e.y - t.y, 2));
}
function yn(e) {
  return {
    x: e.x + e.width / 2,
    y: e.y + e.height / 2
  };
}
function Ot(e, t) {
  return {
    x: e.x - t.x,
    y: e.y - t.y
  };
}
function ot(e, t, n) {
  var r = yn(t), i = yn(n), o = Ot(e, r), a = {
    x: o.x * (n.width / t.width),
    y: o.y * (n.height / t.height)
  };
  return ur({
    x: i.x + a.x,
    y: i.y + a.y
  });
}
function Bt(e, t, n) {
  var r = at(e), i = dr(r, t), o = r[0];
  return i.length ? i[i.length - 1] : ot(o.original || o, n, t);
}
function Ft(e, t, n) {
  var r = at(e), i = dr(r, t), o = r[r.length - 1];
  return i.length ? i[0] : ot(o.original || o, n, t);
}
function Ut(e, t, n) {
  var r = at(e), i = hr(t, n), o = r[0];
  return ot(o.original || o, i, t);
}
function zt(e, t, n) {
  var r = at(e), i = hr(t, n), o = r[r.length - 1];
  return ot(o.original || o, i, t);
}
function hr(e, t) {
  return {
    x: e.x - t.x,
    y: e.y - t.y,
    width: e.width,
    height: e.height
  };
}
function at(e) {
  var t = e.waypoints;
  if (!t.length)
    throw new Error("connection#" + e.id + ": no waypoints");
  return t;
}
function dr(e, t) {
  var n = ae(e, so);
  return Ce(n, function(r) {
    return ao(r, t);
  });
}
function ao(e, t) {
  return io(t, e, 1) === "intersect";
}
function so(e) {
  return e.original || e;
}
function Gt() {
  this.allShapes = {}, this.allConnections = {}, this.enclosedElements = {}, this.enclosedConnections = {}, this.topLevel = {};
}
Gt.prototype.add = function(e, t) {
  return this.addAll([e], t);
};
Gt.prototype.addAll = function(e, t) {
  var n = Hi(e, !!t, this);
  return R(this, n), this;
};
function Ie(e) {
  this._modeling = e;
}
Ie.prototype.moveRecursive = function(e, t, n) {
  return e ? this.moveClosure(this.getClosure(e), t, n) : [];
};
Ie.prototype.moveClosure = function(e, t, n, r, i) {
  var o = this._modeling, a = e.allShapes, s = e.allConnections, c = e.enclosedConnections, u = e.topLevel, l = !1;
  i && i.parent === n && (l = !0), v(a, function(h) {
    o.moveShape(h, t, u[h.id] && !l && n, {
      recurse: !1,
      layout: !1
    });
  }), v(s, function(h) {
    var d = !!a[h.source.id], S = !!a[h.target.id];
    c[h.id] && d && S ? o.moveConnection(h, t, u[h.id] && !l && n) : o.layoutConnection(h, {
      connectionStart: d && Ut(h, h.source, t),
      connectionEnd: S && zt(h, h.target, t)
    });
  });
};
Ie.prototype.getClosure = function(e) {
  return new Gt().addAll(e, !0);
};
function st(e) {
  this._helper = new Ie(e);
}
st.$inject = ["modeling"];
st.prototype.preExecute = function(e) {
  e.closure = this._helper.getClosure(e.shapes);
};
st.prototype.postExecute = function(e) {
  var t = e.hints, n;
  t && t.primaryShape && (n = t.primaryShape, t.oldParent = n.parent), this._helper.moveClosure(
    e.closure,
    e.delta,
    e.newParent,
    e.newHost,
    n
  );
};
function ce(e) {
  this._modeling = e, this._helper = new Ie(e);
}
ce.$inject = ["modeling"];
ce.prototype.execute = function(e) {
  var t = e.shape, n = e.delta, r = e.newParent || t.parent, i = e.newParentIndex, o = t.parent;
  return e.oldBounds = Tt(t, ["x", "y", "width", "height"]), e.oldParent = o, e.oldParentIndex = nt(o.children, t), se(r.children, t, i), R(t, {
    parent: r,
    x: t.x + n.x,
    y: t.y + n.y
  }), t;
};
ce.prototype.postExecute = function(e) {
  var t = e.shape, n = e.delta, r = e.hints, i = this._modeling;
  r.layout !== !1 && (v(t.incoming, function(o) {
    i.layoutConnection(o, {
      connectionEnd: zt(o, t, n)
    });
  }), v(t.outgoing, function(o) {
    i.layoutConnection(o, {
      connectionStart: Ut(o, t, n)
    });
  })), r.recurse !== !1 && this.moveChildren(e);
};
ce.prototype.revert = function(e) {
  var t = e.shape, n = e.oldParent, r = e.oldParentIndex, i = e.delta;
  return se(n.children, t, r), R(t, {
    parent: n,
    x: t.x - i.x,
    y: t.y - i.y
  }), t;
};
ce.prototype.moveChildren = function(e) {
  var t = e.delta, n = e.shape;
  this._helper.moveRecursive(n.children, t, null);
};
ce.prototype.getNewParent = function(e) {
  return e.newParent || e.shape.parent;
};
function He(e) {
  this._modeling = e;
}
He.$inject = ["modeling"];
He.prototype.execute = function(e) {
  var t = e.newSource, n = e.newTarget, r = e.connection, i = e.dockingOrPoints;
  if (!t && !n)
    throw new Error("newSource or newTarget required");
  return D(i) && (e.oldWaypoints = r.waypoints, r.waypoints = i), t && (e.oldSource = r.source, r.source = t), n && (e.oldTarget = r.target, r.target = n), r;
};
He.prototype.postExecute = function(e) {
  var t = e.connection, n = e.newSource, r = e.newTarget, i = e.dockingOrPoints, o = e.hints || {}, a = {};
  o.connectionStart && (a.connectionStart = o.connectionStart), o.connectionEnd && (a.connectionEnd = o.connectionEnd), o.layoutConnection !== !1 && (n && (!r || o.docking === "source") && (a.connectionStart = a.connectionStart || vn(D(i) ? i[0] : i)), r && (!n || o.docking === "target") && (a.connectionEnd = a.connectionEnd || vn(D(i) ? i[i.length - 1] : i)), o.newWaypoints && (a.waypoints = o.newWaypoints), this._modeling.layoutConnection(t, a));
};
He.prototype.revert = function(e) {
  var t = e.oldSource, n = e.oldTarget, r = e.oldWaypoints, i = e.connection;
  return t && (i.source = t), n && (i.target = n), r && (i.waypoints = r), i;
};
function vn(e) {
  return e.original || e;
}
function X(e, t) {
  this._modeling = e, this._rules = t;
}
X.$inject = ["modeling", "rules"];
X.prototype.preExecute = function(e) {
  var t = this, n = this._modeling, r = this._rules, i = e.oldShape, o = e.newData, a = e.hints || {}, s;
  function c(p, b, y) {
    return r.allowed("connection.reconnect", {
      connection: y,
      source: p,
      target: b
    });
  }
  var u = {
    x: o.x,
    y: o.y
  }, l = {
    x: i.x,
    y: i.y,
    width: i.width,
    height: i.height
  };
  s = e.newShape = e.newShape || t.createShape(o, u, i.parent, a), i.host && n.updateAttachment(s, i.host);
  var h;
  a.moveChildren !== !1 && (h = i.children.slice(), n.moveElements(h, { x: 0, y: 0 }, s, a));
  var d = i.incoming.slice(), S = i.outgoing.slice();
  v(d, function(p) {
    var b = p.source, y = c(b, s, p);
    y && t.reconnectEnd(
      p,
      s,
      Ft(p, s, l),
      a
    );
  }), v(S, function(p) {
    var b = p.target, y = c(s, b, p);
    y && t.reconnectStart(
      p,
      s,
      Bt(p, s, l),
      a
    );
  });
};
X.prototype.postExecute = function(e) {
  var t = e.oldShape;
  this._modeling.removeShape(t);
};
X.prototype.execute = function(e) {
};
X.prototype.revert = function(e) {
};
X.prototype.createShape = function(e, t, n, r) {
  return this._modeling.createShape(e, t, n, r);
};
X.prototype.reconnectStart = function(e, t, n, r) {
  this._modeling.reconnectStart(e, t, n, r);
};
X.prototype.reconnectEnd = function(e, t, n, r) {
  this._modeling.reconnectEnd(e, t, n, r);
};
function Ne(e) {
  this._modeling = e;
}
Ne.$inject = ["modeling"];
Ne.prototype.execute = function(e) {
  var t = e.shape, n = e.newBounds, r = e.minBounds;
  if (n.x === void 0 || n.y === void 0 || n.width === void 0 || n.height === void 0)
    throw new Error("newBounds must have {x, y, width, height} properties");
  if (r && (n.width < r.width || n.height < r.height))
    throw new Error("width and height cannot be less than minimum height and width");
  if (!r && n.width < 10 || n.height < 10)
    throw new Error("width and height cannot be less than 10px");
  return e.oldBounds = {
    width: t.width,
    height: t.height,
    x: t.x,
    y: t.y
  }, R(t, {
    width: n.width,
    height: n.height,
    x: n.x,
    y: n.y
  }), t;
};
Ne.prototype.postExecute = function(e) {
  var t = this._modeling, n = e.shape, r = e.oldBounds, i = e.hints || {};
  i.layout !== !1 && (v(n.incoming, function(o) {
    t.layoutConnection(o, {
      connectionEnd: Ft(o, n, r)
    });
  }), v(n.outgoing, function(o) {
    t.layoutConnection(o, {
      connectionStart: Bt(o, n, r)
    });
  }));
};
Ne.prototype.revert = function(e) {
  var t = e.shape, n = e.oldBounds;
  return R(t, {
    width: n.width,
    height: n.height,
    x: n.x,
    y: n.y
  }), t;
};
function co(e, t) {
  var n = [];
  return v(e.concat(t), function(r) {
    var i = r.incoming, o = r.outgoing;
    v(i.concat(o), function(a) {
      var s = a.source, c = a.target;
      (be(e, s) || be(e, c) || be(t, s) || be(t, c)) && (be(n, a) || n.push(a));
    });
  }), n;
}
function be(e, t) {
  return e.indexOf(t) !== -1;
}
function lo(e, t, n) {
  var r = e.x, i = e.y, o = e.width, a = e.height, s = n.x, c = n.y;
  switch (t) {
    case "n":
      return {
        x: r,
        y: i + c,
        width: o,
        height: a - c
      };
    case "s":
      return {
        x: r,
        y: i,
        width: o,
        height: a + c
      };
    case "w":
      return {
        x: r + s,
        y: i,
        width: o - s,
        height: a
      };
    case "e":
      return {
        x: r,
        y: i,
        width: o + s,
        height: a
      };
    default:
      throw new Error("unknown direction: " + t);
  }
}
function ne(e) {
  this._modeling = e;
}
ne.$inject = ["modeling"];
ne.prototype.preExecute = function(e) {
  var t = e.delta, n = e.direction, r = e.movingShapes, i = e.resizingShapes, o = e.start, a = {};
  this.moveShapes(r, t), v(i, function(s) {
    a[s.id] = ho(s);
  }), this.resizeShapes(i, t, n), this.updateConnectionWaypoints(
    co(r, i),
    t,
    n,
    o,
    r,
    i,
    a
  );
};
ne.prototype.execute = function() {
};
ne.prototype.revert = function() {
};
ne.prototype.moveShapes = function(e, t) {
  var n = this;
  v(e, function(r) {
    n._modeling.moveShape(r, t, null, {
      autoResize: !1,
      layout: !1,
      recurse: !1
    });
  });
};
ne.prototype.resizeShapes = function(e, t, n) {
  var r = this;
  v(e, function(i) {
    var o = lo(i, n, t);
    r._modeling.resizeShape(i, o, null, {
      attachSupport: !1,
      autoResize: !1,
      layout: !1
    });
  });
};
ne.prototype.updateConnectionWaypoints = function(e, t, n, r, i, o, a) {
  var s = this, c = i.concat(o);
  v(e, function(u) {
    var l = u.source, h = u.target, d = uo(u), S = fr(n), p = {};
    Q(c, l) && Q(c, h) ? (d = ae(d, function(b) {
      return mn(b, r, n) && (b[S] = b[S] + t[S]), b.original && mn(b.original, r, n) && (b.original[S] = b.original[S] + t[S]), b;
    }), s._modeling.updateWaypoints(u, d, {
      labelBehavior: !1
    })) : (Q(c, l) || Q(c, h)) && (Q(i, l) ? p.connectionStart = Ut(u, l, t) : Q(i, h) ? p.connectionEnd = zt(u, h, t) : Q(o, l) ? p.connectionStart = Bt(
      u,
      l,
      a[l.id]
    ) : Q(o, h) && (p.connectionEnd = Ft(
      u,
      h,
      a[h.id]
    )), s._modeling.layoutConnection(u, p));
  });
};
function _n(e) {
  return R({}, e);
}
function uo(e) {
  return ae(e.waypoints, function(t) {
    return t = _n(t), t.original && (t.original = _n(t.original)), t;
  });
}
function fr(e) {
  switch (e) {
    case "n":
      return "y";
    case "w":
      return "x";
    case "s":
      return "y";
    case "e":
      return "x";
  }
}
function mn(e, t, n) {
  var r = fr(n);
  if (/e|s/.test(n))
    return e[r] > t;
  if (/n|w/.test(n))
    return e[r] < t;
}
function Q(e, t) {
  return e.indexOf(t) !== -1;
}
function ho(e) {
  return {
    x: e.x,
    y: e.y,
    height: e.height,
    width: e.width
  };
}
function ct(e) {
  this._modeling = e;
}
ct.$inject = ["modeling"];
ct.prototype.execute = function(e) {
  var t = e.shape, n = t.children;
  e.oldChildrenVisibility = pr(n), t.collapsed = !t.collapsed;
  var r = gr(n, t.collapsed);
  return [t].concat(r);
};
ct.prototype.revert = function(e) {
  var t = e.shape, n = e.oldChildrenVisibility, r = t.children, i = yr(r, n);
  return t.collapsed = !t.collapsed, [t].concat(i);
};
function pr(e) {
  var t = {};
  return v(e, function(n) {
    t[n.id] = n.hidden, n.children && (t = R({}, t, pr(n.children)));
  }), t;
}
function gr(e, t) {
  var n = [];
  return v(e, function(r) {
    r.hidden = t, n = n.concat(r), r.children && (n = n.concat(gr(r.children, r.collapsed || t)));
  }), n;
}
function yr(e, t) {
  var n = [];
  return v(e, function(r) {
    r.hidden = t[r.id], n = n.concat(r), r.children && (n = n.concat(yr(r.children, t)));
  }), n;
}
function lt(e) {
  this._modeling = e;
}
lt.$inject = ["modeling"];
lt.prototype.execute = function(e) {
  var t = e.shape, n = e.newHost, r = t.host;
  return e.oldHost = r, e.attacherIdx = vr(r, t), _r(n, t), t.host = n, t;
};
lt.prototype.revert = function(e) {
  var t = e.shape, n = e.newHost, r = e.oldHost, i = e.attacherIdx;
  return t.host = r, vr(n, t), _r(r, t, i), t;
};
function vr(e, t) {
  return nt(e && e.attachers, t);
}
function _r(e, t, n) {
  if (e) {
    var r = e.attachers;
    r || (e.attachers = r = []), se(r, t, n);
  }
}
function Vt() {
}
Vt.prototype.execute = function(e) {
  var t = e.connection, n = e.newWaypoints;
  return e.oldWaypoints = t.waypoints, t.waypoints = n, t;
};
Vt.prototype.revert = function(e) {
  var t = e.connection, n = e.oldWaypoints;
  return t.waypoints = n, t;
};
function fo(e, t, n, r) {
  var i = n.inverse;
  return Object.defineProperty(e, "remove", {
    value: function(o) {
      var a = this.indexOf(o);
      return a !== -1 && (this.splice(a, 1), t.unset(o, i, r)), o;
    }
  }), Object.defineProperty(e, "contains", {
    value: function(o) {
      return this.indexOf(o) !== -1;
    }
  }), Object.defineProperty(e, "add", {
    value: function(o, a) {
      var s = this.indexOf(o);
      if (typeof a > "u") {
        if (s !== -1)
          return;
        a = this.length;
      }
      s !== -1 && this.splice(s, 1), this.splice(a, 0, o), s === -1 && t.set(o, i, r);
    }
  }), Object.defineProperty(e, "__refs_collection", {
    value: !0
  }), e;
}
function po(e) {
  return e.__refs_collection === !0;
}
function go(e, t) {
  return Object.prototype.hasOwnProperty.call(e, t.name || t);
}
function mr(e, t, n) {
  var r = fo(n[t.name] || [], e, t, n);
  Object.defineProperty(n, t.name, {
    enumerable: t.enumerable,
    value: r
  }), r.length && r.forEach(function(i) {
    e.set(i, t.inverse, n);
  });
}
function yo(e, t, n) {
  var r = t.inverse, i = n[t.name];
  Object.defineProperty(n, t.name, {
    configurable: t.configurable,
    enumerable: t.enumerable,
    get: function() {
      return i;
    },
    set: function(o) {
      if (o !== i) {
        var a = i;
        i = null, a && e.unset(a, r, n), i = o, e.set(i, r, n);
      }
    }
  });
}
function V(e, t) {
  if (!(this instanceof V))
    return new V(e, t);
  e.inverse = t, t.inverse = e, this.props = {}, this.props[e.name] = e, this.props[t.name] = t;
}
V.prototype.bind = function(e, t) {
  if (typeof t == "string") {
    if (!this.props[t])
      throw new Error("no property <" + t + "> in ref");
    t = this.props[t];
  }
  t.collection ? mr(this, t, e) : yo(this, t, e);
};
V.prototype.ensureRefsCollection = function(e, t) {
  var n = e[t.name];
  return po(n) || mr(this, t, e), n;
};
V.prototype.ensureBound = function(e, t) {
  go(e, t) || this.bind(e, t);
};
V.prototype.unset = function(e, t, n) {
  e && (this.ensureBound(e, t), t.collection ? this.ensureRefsCollection(e, t).remove(n) : e[t.name] = void 0);
};
V.prototype.set = function(e, t, n) {
  e && (this.ensureBound(e, t), t.collection ? this.ensureRefsCollection(e, t).add(n) : e[t.name] = n);
};
var Wt = new V({ name: "children", enumerable: !0, collection: !0 }, { name: "parent" }), Sr = new V({ name: "labels", enumerable: !0, collection: !0 }, { name: "labelTarget" }), Sn = new V({ name: "attachers", collection: !0 }, { name: "host" }), Er = new V({ name: "outgoing", collection: !0 }, { name: "source" }), br = new V({ name: "incoming", collection: !0 }, { name: "target" });
function fe() {
  Object.defineProperty(this, "businessObject", {
    writable: !0
  }), Object.defineProperty(this, "label", {
    get: function() {
      return this.labels[0];
    },
    set: function(e) {
      var t = this.label, n = this.labels;
      !e && t ? n.remove(t) : n.add(e, 0);
    }
  }), Wt.bind(this, "parent"), Sr.bind(this, "labels"), Er.bind(this, "outgoing"), br.bind(this, "incoming");
}
function De() {
  fe.call(this), Wt.bind(this, "children"), Sn.bind(this, "host"), Sn.bind(this, "attachers");
}
Ae(De, fe);
function wr() {
  fe.call(this), Wt.bind(this, "children");
}
Ae(wr, De);
function xr() {
  De.call(this), Sr.bind(this, "labelTarget");
}
Ae(xr, De);
function Cr() {
  fe.call(this), Er.bind(this, "source"), br.bind(this, "target");
}
Ae(Cr, fe);
var vo = {
  connection: Cr,
  shape: De,
  label: xr,
  root: wr
};
function _o(e, t) {
  var n = vo[e];
  if (!n)
    throw new Error("unknown type: <" + e + ">");
  return R(new n(), t);
}
function mo(e) {
  return e instanceof fe;
}
function k(e, t, n) {
  this._eventBus = e, this._elementFactory = t, this._commandStack = n;
  var r = this;
  e.on("diagram.init", function() {
    r.registerHandlers(n);
  });
}
k.$inject = ["eventBus", "elementFactory", "commandStack"];
k.prototype.getHandlers = function() {
  return {
    "shape.append": et,
    "shape.create": te,
    "shape.delete": je,
    "shape.move": ce,
    "shape.resize": Ne,
    "shape.replace": X,
    "shape.toggleCollapse": ct,
    spaceTool: ne,
    "label.create": Me,
    "connection.create": tt,
    "connection.delete": Pe,
    "connection.move": Dt,
    "connection.layout": it,
    "connection.updateWaypoints": Vt,
    "connection.reconnect": He,
    "elements.create": Ht,
    "elements.move": st,
    "elements.delete": Nt,
    "elements.distribute": rt,
    "elements.align": Qe,
    "element.updateAttachment": lt
  };
};
k.prototype.registerHandlers = function(e) {
  v(this.getHandlers(), function(t, n) {
    e.registerHandler(n, t);
  });
};
k.prototype.moveShape = function(e, t, n, r, i) {
  typeof r == "object" && (i = r, r = null);
  var o = {
    shape: e,
    delta: t,
    newParent: n,
    newParentIndex: r,
    hints: i || {}
  };
  this._commandStack.execute("shape.move", o);
};
k.prototype.updateAttachment = function(e, t) {
  var n = {
    shape: e,
    newHost: t
  };
  this._commandStack.execute("element.updateAttachment", n);
};
k.prototype.moveElements = function(e, t, n, r) {
  r = r || {};
  var i = r.attach, o = n, a;
  i === !0 ? (a = n, o = n.parent) : i === !1 && (a = null);
  var s = {
    shapes: e,
    delta: t,
    newParent: o,
    newHost: a,
    hints: r
  };
  this._commandStack.execute("elements.move", s);
};
k.prototype.moveConnection = function(e, t, n, r, i) {
  typeof r == "object" && (i = r, r = void 0);
  var o = {
    connection: e,
    delta: t,
    newParent: n,
    newParentIndex: r,
    hints: i || {}
  };
  this._commandStack.execute("connection.move", o);
};
k.prototype.layoutConnection = function(e, t) {
  var n = {
    connection: e,
    hints: t || {}
  };
  this._commandStack.execute("connection.layout", n);
};
k.prototype.createConnection = function(e, t, n, r, i, o) {
  typeof n == "object" && (o = i, i = r, r = n, n = void 0), r = this._create("connection", r);
  var a = {
    source: e,
    target: t,
    parent: i,
    parentIndex: n,
    connection: r,
    hints: o
  };
  return this._commandStack.execute("connection.create", a), a.connection;
};
k.prototype.createShape = function(e, t, n, r, i) {
  typeof r != "number" && (i = r, r = void 0), i = i || {};
  var o = i.attach, a, s;
  e = this._create("shape", e), o ? (a = n.parent, s = n) : a = n;
  var c = {
    position: t,
    shape: e,
    parent: a,
    parentIndex: r,
    host: s,
    hints: i
  };
  return this._commandStack.execute("shape.create", c), c.shape;
};
k.prototype.createElements = function(e, t, n, r, i) {
  D(e) || (e = [e]), typeof r != "number" && (i = r, r = void 0), i = i || {};
  var o = {
    position: t,
    elements: e,
    parent: n,
    parentIndex: r,
    hints: i
  };
  return this._commandStack.execute("elements.create", o), o.elements;
};
k.prototype.createLabel = function(e, t, n, r) {
  n = this._create("label", n);
  var i = {
    labelTarget: e,
    position: t,
    parent: r || e.parent,
    shape: n
  };
  return this._commandStack.execute("label.create", i), i.shape;
};
k.prototype.appendShape = function(e, t, n, r, i) {
  i = i || {}, t = this._create("shape", t);
  var o = {
    source: e,
    position: n,
    target: r,
    shape: t,
    connection: i.connection,
    connectionParent: i.connectionParent,
    hints: i
  };
  return this._commandStack.execute("shape.append", o), o.shape;
};
k.prototype.removeElements = function(e) {
  var t = {
    elements: e
  };
  this._commandStack.execute("elements.delete", t);
};
k.prototype.distributeElements = function(e, t, n) {
  var r = {
    groups: e,
    axis: t,
    dimension: n
  };
  this._commandStack.execute("elements.distribute", r);
};
k.prototype.removeShape = function(e, t) {
  var n = {
    shape: e,
    hints: t || {}
  };
  this._commandStack.execute("shape.delete", n);
};
k.prototype.removeConnection = function(e, t) {
  var n = {
    connection: e,
    hints: t || {}
  };
  this._commandStack.execute("connection.delete", n);
};
k.prototype.replaceShape = function(e, t, n) {
  var r = {
    oldShape: e,
    newData: t,
    hints: n || {}
  };
  return this._commandStack.execute("shape.replace", r), r.newShape;
};
k.prototype.alignElements = function(e, t) {
  var n = {
    elements: e,
    alignment: t
  };
  this._commandStack.execute("elements.align", n);
};
k.prototype.resizeShape = function(e, t, n, r) {
  var i = {
    shape: e,
    newBounds: t,
    minBounds: n,
    hints: r
  };
  this._commandStack.execute("shape.resize", i);
};
k.prototype.createSpace = function(e, t, n, r, i) {
  var o = {
    delta: n,
    direction: r,
    movingShapes: e,
    resizingShapes: t,
    start: i
  };
  this._commandStack.execute("spaceTool", o);
};
k.prototype.updateWaypoints = function(e, t, n) {
  var r = {
    connection: e,
    newWaypoints: t,
    hints: n || {}
  };
  this._commandStack.execute("connection.updateWaypoints", r);
};
k.prototype.reconnect = function(e, t, n, r, i) {
  var o = {
    connection: e,
    newSource: t,
    newTarget: n,
    dockingOrPoints: r,
    hints: i || {}
  };
  this._commandStack.execute("connection.reconnect", o);
};
k.prototype.reconnectStart = function(e, t, n, r) {
  r || (r = {}), this.reconnect(e, t, e.target, n, R(r, {
    docking: "source"
  }));
};
k.prototype.reconnectEnd = function(e, t, n, r) {
  r || (r = {}), this.reconnect(e, e.source, t, n, R(r, {
    docking: "target"
  }));
};
k.prototype.connect = function(e, t, n, r) {
  return this.createConnection(e, t, n || {}, e.parent, r);
};
k.prototype._create = function(e, t) {
  return mo(t) ? t : this._elementFactory.create(e, t);
};
k.prototype.toggleCollapse = function(e, t) {
  var n = {
    shape: e,
    hints: t || {}
  };
  this._commandStack.execute("shape.toggleCollapse", n);
};
function Kt() {
}
Kt.prototype.layoutConnection = function(e, t) {
  return t = t || {}, [
    t.connectionStart || gn(t.source || e.source),
    t.connectionEnd || gn(t.target || e.target)
  ];
};
const So = {
  __depends__: [
    ji,
    Di,
    jt,
    Zi
  ],
  __init__: ["modeling"],
  modeling: ["type", k],
  layouter: ["type", Kt]
};
var Eo = /^djs-cursor-.*$/;
function Tr(e) {
  var t = Z(document.body);
  t.removeMatching(Eo), e && t.add("djs-cursor-" + e);
}
function bo() {
  Tr(null);
}
var wo = 5e3;
function xo(e, t) {
  t = t || "element.click";
  function n() {
    return !1;
  }
  return e.once(t, wo, n), function() {
    e.off(t, n);
  };
}
var Co = 15;
function kr(e, t) {
  var n;
  function r(s) {
    return a(s.originalEvent);
  }
  e.on("canvas.focus.changed", function(s) {
    s.focused ? e.on("element.mousedown", 500, r) : e.off("element.mousedown", r);
  });
  function i(s) {
    var c = n.start, u = n.button, l = cn(s), h = Ot(l, c);
    if (!n.dragging && To(h) > Co && (n.dragging = !0, u === 0 && xo(e), Tr("grab")), n.dragging) {
      var d = n.last || n.start;
      h = Ot(l, d), t.scroll({
        dx: h.x,
        dy: h.y
      }), n.last = l;
    }
    s.preventDefault();
  }
  function o(s) {
    q.unbind(document, "mousemove", i), q.unbind(document, "mouseup", o), n = null, bo();
  }
  function a(s) {
    if (!wi(s.target, ".djs-draggable")) {
      var c = s.button;
      if (!(c >= 2 || s.ctrlKey || s.shiftKey || s.altKey))
        return n = {
          button: c,
          start: cn(s)
        }, q.bind(document, "mousemove", i), q.bind(document, "mouseup", o), !0;
    }
  }
  this.isActive = function() {
    return !!n;
  };
}
kr.$inject = [
  "eventBus",
  "canvas"
];
function To(e) {
  return Math.sqrt(Math.pow(e.x, 2) + Math.pow(e.y, 2));
}
const ko = {
  __init__: ["moveCanvas"],
  moveCanvas: ["type", kr]
};
function Rt(e) {
  return Math.log(e) / Math.log(10);
}
function Or(e, t) {
  var n = Rt(e.min), r = Rt(e.max), i = Math.abs(n) + Math.abs(r);
  return i / t;
}
function Oo(e, t) {
  return Math.max(e.min, Math.min(e.max, t));
}
var Ro = Math.sign || function(e) {
  return e >= 0 ? 1 : -1;
}, Yt = { min: 0.2, max: 4 }, Rr = 10, $o = 0.1, Lo = 0.75;
function K(e, t, n) {
  e = e || {}, this._enabled = !1, this._canvas = n, this._container = n._container, this._handleWheel = Mi(this._handleWheel, this), this._totalDelta = 0, this._scale = e.scale || Lo;
  var r = this;
  t.on("canvas.focus.changed", function(i) {
    r._init(i.focused && e.enabled !== !1);
  });
}
K.$inject = [
  "config.zoomScroll",
  "eventBus",
  "canvas"
];
K.prototype.scroll = function(t) {
  this._canvas.scroll(t);
};
K.prototype.reset = function() {
  this._canvas.zoom("fit-viewport");
};
K.prototype.zoom = function(t, n) {
  var r = Or(Yt, Rr * 2);
  this._totalDelta += t, Math.abs(this._totalDelta) > $o && (this._zoom(t, n, r), this._totalDelta = 0);
};
K.prototype._handleWheel = function(t) {
  if (this._canvas.isFocused()) {
    var n = this._container;
    t.preventDefault();
    var r = t.ctrlKey || Bi() && t.metaKey, i = t.shiftKey, o = -1 * this._scale, a;
    if (r ? o *= t.deltaMode === 0 ? 0.02 : 0.32 : o *= t.deltaMode === 0 ? 1 : 16, r) {
      var s = n.getBoundingClientRect(), c = {
        x: t.clientX - s.left,
        y: t.clientY - s.top
      };
      a = Math.sqrt(
        Math.pow(t.deltaY, 2) + Math.pow(t.deltaX, 2)
      ) * Ro(t.deltaY) * o, this.zoom(a, c);
    } else
      i ? a = {
        dx: o * t.deltaY,
        dy: 0
      } : a = {
        dx: o * t.deltaX,
        dy: o * t.deltaY
      }, this.scroll(a);
  }
};
K.prototype.stepZoom = function(t, n) {
  var r = Or(Yt, Rr);
  this._zoom(t, n, r);
};
K.prototype._zoom = function(e, t, n) {
  var r = this._canvas, i = e > 0 ? 1 : -1, o = Rt(r.zoom()), a = Math.round(o / n) * n;
  a += n * i;
  var s = Math.pow(10, a);
  r.zoom(Oo(Yt, s), t);
};
K.prototype.toggle = function(t) {
  var n = this._container, r = this._handleWheel, i = this._enabled;
  return typeof t > "u" && (t = !i), i !== t && q[t ? "bind" : "unbind"](n, "wheel", r, !1), this._enabled = t, t;
};
K.prototype._init = function(e) {
  this.toggle(e);
};
const Ao = {
  __init__: ["zoomScroll"],
  zoomScroll: ["type", K]
}, op = Object.freeze({
  PROCESS: "bpmn:Process",
  SUBPROCESS: "bpmn:SubProcess",
  CALL_ACTIVITY: "bpmn:CallActivity",
  SEQUENCE_FLOW: "bpmn:SequenceFlow",
  CALL_ELEMENT: "zeebe:calledElement"
}), j = Object.freeze({
  PROCESS: "process",
  SUBPROCESS: "subprocess",
  REF: "ref_node",
  FEEL: "feel",
  INVALID: "invalid"
}), z = Object.freeze({
  PARENT_OF: "parentOf",
  FLOW: "flow",
  CALL: "call",
  REF: "ref_link"
}), ke = Object.freeze({
  INHERITANCE_TREE: "inheritanceTree",
  CURVED_REFERENCE: "curvedDirected"
}), $t = Object.freeze({
  NODE_LABEL: "nodeLabel",
  NODE_LINK_LABEL: "nodeLinkLabel"
}), Mo = Object.freeze({
  CONNECTION: "connection",
  SHAPE: "shape",
  LABEL: "label",
  ROOT: "root"
});
class Po {
  constructor(t = {}) {
    this._options = {
      hierachicalLinks: [z.PARENT_OF, z.CALL],
      orderLinks: [z.FLOW],
      displayFeelNodes: !0,
      displayInvalidNodes: !1,
      interTreeSpacing: 0.5,
      nodeSpacing: 1,
      ...t
    };
  }
  forEachNodePlacement(t, n) {
    const { nodes: r = [], links: i = [] } = (t == null ? void 0 : t.elements) || {}, { hierachicalLinks: o, interTreeSpacing: a, nodeSpacing: s } = this._options, { nodes: c, links: u } = this._preprocessNodesAndLinks(
      JSON.parse(JSON.stringify(r)),
      JSON.parse(JSON.stringify(i))
    ), l = c.reduce((E, x) => (E[x.id] = { ...x }, E), {}), h = [], { nodeIdToChildren: d } = this._createGraphMaps(u, o), S = /* @__PURE__ */ new Set(), p = {};
    let b = 0;
    const y = (E, x, U = null) => {
      const J = l[E];
      let f;
      if (S.has(E)) {
        const g = p[E] || 0, _ = `ref_${E}_${g + 1}`;
        p[E] = g + 1;
        const L = {
          ...J,
          id: _,
          type: j.REF,
          originalId: E
        };
        return l[_] = L, h.push({
          from: _,
          to: E,
          type: z.REF
        }), U && h.push({
          from: U,
          to: _,
          type: z.PARENT_OF
        }), f = b, b += s, n(L, f, x), f;
      } else {
        S.add(E), U && h.push({
          from: U,
          to: E,
          type: z.PARENT_OF
        });
        const g = [];
        return (d[E] || []).forEach((L) => {
          const B = y(L, x + 1, E);
          g.push(B);
        }), g.length === 0 ? (f = b, b += s) : f = (Math.min(...g) + Math.max(...g)) / 2, n({ searchable: !0, ...J }, f, x), f;
      }
    }, T = (E, x = /* @__PURE__ */ new Set()) => {
      if (x.has(E)) return 0;
      x.add(E);
      const U = d[E] || [];
      return U.length === 0 ? 0 : Math.max(
        ...U.map((f) => T(f, new Set(x)))
      ) + 1;
    }, w = c.reduce((E, x) => (E[x.id] = T(x.id), E), {}), A = [...c].sort(
      (E, x) => w[x.id] - w[E.id]
    );
    for (; S.size < c.length; ) {
      const E = A.find(
        (x) => !S.has(x.id)
      );
      if (!E) break;
      y(E.id, 0), b += a;
    }
    return h;
  }
  _preprocessNodesAndLinks(t, n) {
    let r = 0;
    const { displayFeelNodes: i, displayInvalidNodes: o } = this._options, a = t.reduce((u, l) => (u[l.id] = { ...l }, u), {}), s = [], c = [];
    for (const u of n) {
      if (u.type !== z.CALL || a[u.to]) {
        c.push(u);
        continue;
      }
      if (u.to.startsWith("=") && i) {
        const l = {
          id: `feel_${r++}_${u.to.slice(1)}`,
          type: j.FEEL,
          data: {
            name: u.to
          }
        };
        s.push(l), c.push({ ...u, to: l.id });
      } else if (o) {
        const l = {
          id: u.to,
          type: j.INVALID,
          data: {
            name: `Invalid link to "${u.to}"`
          }
        };
        s.push(l), c.push(u);
      }
    }
    return { nodes: [...t, ...s], links: c };
  }
  _createGraphMaps(t, n) {
    const r = {};
    return t.forEach((i) => {
      n.includes(i.type) && (r[i.from] = r[i.from] || [], r[i.from].push(i.to));
    }), { nodeIdToChildren: r };
  }
}
class $r {
  constructor(t) {
    this._landscapeData = {}, this._activeViewRules = {}, this._landscape = {}, this._eventBus = t, this._eventBus.on("diagram.clear", () => {
      this._clear();
    });
  }
  import(t) {
    this._eventBus.fire("diagram.clear"), this._eventBus.fire("landscape.import", { data: t }), this._landscapeData = t;
    const n = {
      error: null,
      warnings: []
    };
    this._eventBus.fire("landscape.import.done", n), this.setViewRules(), this.computeLandscape(), this._eventBus.fire("landscape.new", {
      landscape: this._landscape,
      viewRules: this._activeViewRules
    });
  }
  getLandscapeData() {
    return this._landscapeData;
  }
  computeLandscape() {
    this._landscape = this._landscapeData;
  }
  getLandscape() {
    return this._landscape;
  }
  setViewRules() {
    this._activeViewRules = {
      placer: new Po()
    };
  }
  getActiveViewRules() {
    return this._activeViewRules;
  }
  _clear() {
    this._landscapeData = {}, this._landscape = {};
  }
}
N($r, "$inject", ["eventBus"]);
function pe() {
  this._uid = 12;
}
pe.prototype.createRoot = function(e) {
  return this.create("root", e);
};
pe.prototype.createLabel = function(e) {
  return this.create("label", e);
};
pe.prototype.createShape = function(e) {
  return this.create("shape", e);
};
pe.prototype.createConnection = function(e) {
  return this.create("connection", e);
};
pe.prototype.create = function(e, t) {
  return t = R({}, t || {}), t.id || (t.id = e + "_" + this._uid++), _o(e, t);
};
class Lr extends pe {
  constructor(t) {
    super(), this._ruleManager = t;
  }
  create(t, n = {}) {
    const r = n.type;
    if (t === Mo.SHAPE && !r)
      throw new Error("No shape type specified");
    return super.create(t, {
      ...this._getShapeDimensions(r),
      ...n
    });
  }
  _getShapeDimensions(t) {
    const { width: n, height: r } = this._ruleManager.getFor({
      category: "node",
      type: t
    }).styles;
    return { width: n, height: r };
  }
}
N(Lr, "$inject", ["ruleManager"]);
var jo = 1e3;
function le(e, t) {
  var n = this;
  t = t || jo, e.on(["render.shape", "render.connection"], t, function(r, i) {
    var o = r.type, a = i.element, s = i.gfx, c = i.attrs;
    if (n.canRender(a))
      return o === "render.shape" ? n.drawShape(s, a, c) : n.drawConnection(s, a, c);
  }), e.on(["render.getShapePath", "render.getConnectionPath"], t, function(r, i) {
    if (n.canRender(i))
      return r.type === "render.getShapePath" ? n.getShapePath(i) : n.getConnectionPath(i);
  });
}
le.prototype.canRender = function(e) {
};
le.prototype.drawShape = function(e, t) {
};
le.prototype.drawConnection = function(e, t) {
};
le.prototype.getShapePath = function(e) {
};
le.prototype.getConnectionPath = function(e) {
};
var Ve = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function qt(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Io = typeof Ve == "object" && Ve && Ve.Object === Object && Ve, Ar = Io, Ho = Ar, No = typeof self == "object" && self && self.Object === Object && self, Do = Ho || No || Function("return this")(), ge = Do, Bo = ge, Fo = Bo.Symbol, Zt = Fo;
function Uo(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length, i = Array(r); ++n < r; )
    i[n] = t(e[n], n, e);
  return i;
}
var zo = Uo, Go = Array.isArray, Xt = Go, En = Zt, Mr = Object.prototype, Vo = Mr.hasOwnProperty, Wo = Mr.toString, we = En ? En.toStringTag : void 0;
function Ko(e) {
  var t = Vo.call(e, we), n = e[we];
  try {
    e[we] = void 0;
    var r = !0;
  } catch {
  }
  var i = Wo.call(e);
  return r && (t ? e[we] = n : delete e[we]), i;
}
var Yo = Ko, qo = Object.prototype, Zo = qo.toString;
function Xo(e) {
  return Zo.call(e);
}
var Jo = Xo, bn = Zt, Qo = Yo, ea = Jo, ta = "[object Null]", na = "[object Undefined]", wn = bn ? bn.toStringTag : void 0;
function ra(e) {
  return e == null ? e === void 0 ? na : ta : wn && wn in Object(e) ? Qo(e) : ea(e);
}
var Be = ra;
function ia(e) {
  return e != null && typeof e == "object";
}
var ye = ia, oa = Be, aa = ye, sa = "[object Symbol]";
function ca(e) {
  return typeof e == "symbol" || aa(e) && oa(e) == sa;
}
var la = ca, xn = Zt, ua = zo, ha = Xt, da = la, fa = 1 / 0, Cn = xn ? xn.prototype : void 0, Tn = Cn ? Cn.toString : void 0;
function Pr(e) {
  if (typeof e == "string")
    return e;
  if (ha(e))
    return ua(e, Pr) + "";
  if (da(e))
    return Tn ? Tn.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -fa ? "-0" : t;
}
var pa = Pr, ga = pa;
function ya(e) {
  return e == null ? "" : ga(e);
}
var va = ya, _a = va, ma = 0;
function Sa(e) {
  var t = ++ma;
  return _a(e) + t;
}
var Ea = Sa;
const jr = /* @__PURE__ */ qt(Ea);
class Ir extends le {
  constructor(t, n, r, i, o, a, s) {
    super(n), this._ruleManager = t || {}, this._eventBus = n, this._elementFactory = r, this._modeling = i, this._canvas = o, this._textRenderer = a, this._styles = s, this._eventBus.on("landscape.new", (c) => {
      const { landscape: u, viewRules: l } = c;
      this.renderLandscape(u, l);
    });
  }
  renderLandscape(t, n) {
    const r = (t == null ? void 0 : t.elements) || {}, { nodes: i = [] } = r;
    if (i.length === 0)
      return;
    const { placer: o } = n, a = this._elementFactory.createRoot({
      id: "root"
    });
    this._canvas.setRootElement(a);
    const { horizontalNodeSpacing: s, verticalNodeSpacing: c, primaryNode: u } = this._ruleManager.getFor({ category: "landscape" }), { styles: l } = this._ruleManager.getFor({
      category: "node",
      type: u
    }), { height: h } = l, d = {};
    o.forEachNodePlacement(t, (p, b, y) => {
      var g;
      const { styles: T } = this._ruleManager.getFor({
        category: "node",
        type: p.type
      }), { height: w } = T, A = (w - h) / 2, E = {
        x: b * s,
        y: y * c + A
      }, x = `_${jr()}`, U = p.id + x, J = (g = p == null ? void 0 : p.data) == null ? void 0 : g.name, f = this._modeling.createShape(
        {
          name: J,
          id: U,
          // todo: this should be removed and references updated to use the businessObject
          type: p.type,
          businessObject: p
        },
        E,
        a
      );
      d[p.id] = f;
    }).forEach(({ type: p, from: b, to: y }) => {
      const T = b && d[b], w = y && d[y];
      if (!T || !w)
        throw "Node placer placed invalid links!";
      [z.CALL, z.PARENT_OF, z.REF].includes(p) && this._modeling.connect(T, w, { type: p, noHit: !0 });
    }), this.initializeViewBox();
  }
  initializeViewBox() {
    this._canvas.zoom("fit-viewport", "auto"), this._canvas.zoom(Math.max(this._canvas.zoom() * 0.9, 0.6));
    const t = this._canvas.viewbox(), n = t.inner.height > t.outer.height, r = {
      ...t,
      y: n ? -60 : t.y
    };
    this._canvas.viewbox(r);
  }
}
N(Ir, "$inject", [
  "ruleManager",
  "eventBus",
  "elementFactory",
  "modeling",
  "canvas",
  "textRenderer",
  "styles"
]);
const Lt = (e, { _attr: t = {}, ...n } = {}) => {
  Object.entries(n).forEach(([r, i]) => {
    e.style[r] = i;
  }), Object.entries(t).forEach(([r, i]) => {
    e.setAttribute(r, i);
  });
}, ba = (e, t = {}) => {
  const n = document.createElementNS("http://www.w3.org/2000/svg", "svg"), r = document.createElementNS(
    "http://www.w3.org/2000/svg",
    "text"
  );
  r.textContent = e, Lt(r, t), n.appendChild(r), document.body.appendChild(n);
  const i = r.getBBox();
  return document.body.removeChild(n), {
    width: i.width,
    height: i.height
  };
}, wa = (e, {
  tension: t = 0.5,
  closed: n = !1,
  startOrientation: r = null,
  endOrientation: i = null
} = {}) => {
  if (e.length < 2) return "";
  const o = [...e];
  n ? (o.unshift(e[e.length - 1]), o.push(e[0], e[1])) : (o.unshift(e[0]), o.push(e[e.length - 1]));
  let a = `M ${e[0].x} ${e[0].y}`;
  for (let s = 1; s < o.length - 2; s++) {
    const c = o[s - 1], u = o[s], l = o[s + 1], h = o[s + 2];
    let d = {
      x: u.x + (l.x - c.x) * t / 6,
      y: u.y + (l.y - c.y) * t / 6
    }, S = {
      x: l.x - (h.x - u.x) * t / 6,
      y: l.y - (h.y - u.y) * t / 6
    };
    if (s === 1 && r) {
      const p = kn(r, u, l);
      d = {
        x: u.x + p.x * t,
        y: u.y + p.y * t
      };
    }
    if (s === o.length - 3 && i) {
      const p = kn(i, l, u);
      S = {
        x: l.x - p.x * t,
        y: l.y - p.y * t
      };
    }
    a += ` C ${d.x} ${d.y}, ${S.x} ${S.y}, ${l.x} ${l.y}`;
  }
  return n && (a += " Z"), a;
}, kn = (e, t, n) => {
  if (typeof e == "number")
    return {
      x: Math.cos(e),
      y: Math.sin(e)
    };
  if (e.x !== void 0 && e.y !== void 0) {
    const r = Math.sqrt(e.x ** 2 + e.y ** 2);
    return {
      x: e.x / r,
      y: e.y / r
    };
  } else {
    const r = {
      x: n.x - t.x,
      y: n.y - t.y
    }, i = Math.sqrt(r.x ** 2 + r.y ** 2);
    return {
      x: r.x / i,
      y: r.y / i
    };
  }
}, St = {
  stroke: "pink",
  fill: "none"
}, xa = {
  stroke: "pink",
  fill: "pink"
};
class Hr extends le {
  constructor(t, n, r, i, o, a, s, c, u) {
    super(t), this.textRenderer = n, this.defaultRenderer = i, this.canvas = r, this.markers = {}, this.linkHandler = o.get("linkHandler", !1), this.nodeAdorners = a, this.markerHelper = s, this.nodeSelection = c, this.ruleManager = u, this.handlers = this.initializeHandlers();
  }
  drawPath(t, n, r) {
    r = {
      ...St,
      ...r
    };
    const i = F("path");
    return M(i, { d: n }), M(i, r), G(t, i), i;
  }
  drawLine(t, n, r) {
    r = {
      ...St,
      ...r
    };
    const i = ir(n, r);
    return G(t, i), i;
  }
  drawSmoothCurve(t, n, r, i = {}) {
    if (n.length < 2) return null;
    r = {
      ...St,
      ...r
    };
    const { tension: o = 0.5, closed: a = !1 } = i, s = { x: 0, y: -2 }, c = wa(n, {
      tension: o,
      closed: a,
      startOrientation: s,
      endOrientation: s
    }), u = F("path");
    return M(u, { d: c }), M(u, r), G(t, u), u;
  }
  drawRect(t, n, r, i, o = 0, a) {
    typeof o == "object" && (a = o, o = 0), a = {
      ...xa,
      ...a
    };
    const s = F("rect");
    return M(s, {
      x: o,
      y: o,
      width: n - o * 2,
      height: r - o * 2,
      rx: i,
      ry: i
    }), M(s, a), G(t, s), s;
  }
  renderLabel(t, n, r) {
    const i = this.textRenderer.createText(n || "", r);
    return Re(i, "class", "djs-label"), r.onTextClick && i.addEventListener("click", r.onTextClick), G(t, i), i;
  }
  renderEmbeddedLabel(t, n) {
    var u;
    const r = ((u = this.linkHandler) == null ? void 0 : u.hasLink(n)) || !1, { styles: i } = this.ruleManager.getFor({
      category: "label",
      type: r ? $t.NODE_LINK_LABEL : $t.NODE_LABEL,
      parentType: n.type
    }), { align: o, padding: a, ...s } = i, c = {
      box: { width: n.width, height: n.height },
      element: n,
      align: o,
      padding: a,
      style: {
        ...s
      },
      onTextClick: r ? () => this.linkHandler.onClickLink(n) : null
    };
    return this.renderLabel(t, n.name, c);
  }
  /**
   * Render adorners for a node and append them to an SVG group.
   * @param {Object} parent - The parent SVG group where the adorners will be rendered.
   * @param {Object} node - The node to render adorners for.
   * @returns {Object} The created SVG group containing the adorners.
   */
  renderNodeAdorners(t, n) {
    const r = F("g");
    return M(r, { class: "pl-node-adorners-group" }), G(t, r), this.nodeAdorners.renderAdorners(n, r, {
      fill: "transparent"
    }), r;
  }
  drawShape(t, n) {
    const r = this.handlers[n.type];
    return r ? r(t, n) : super.drawShape(t, n);
  }
  drawConnection(t, n) {
    const { linkDrawingType: r } = this.ruleManager.getFor({
      category: "link",
      type: n.type
    }), i = this.handlers[r];
    return i ? i(t, n) : super.drawConnection(t, n);
  }
  canRender() {
    return !0;
  }
  initializeHandlers() {
    const t = (i, o) => {
      const { styles: a } = this.ruleManager.getFor({
        category: "node",
        type: o.type
      }), s = this.drawRect(i, o.width, o.height, 0, {
        ...a
      });
      return this.renderEmbeddedLabel(i, o), this.renderNodeAdorners(i, o), s;
    }, n = (i, { waypoints: o, type: a }) => {
      const { styles: s } = this.ruleManager.getFor({
        category: "link",
        type: a
      });
      return this.drawLine(i, o, {
        markerEnd: this.markerHelper.marker(
          "inheritance-end",
          s.stroke
        ),
        ...s
      });
    }, r = (i, { waypoints: o, type: a }) => {
      const {
        styles: s,
        tension: c,
        closed: u
      } = this.ruleManager.getFor({
        category: "link",
        type: a
      });
      return this.drawSmoothCurve(
        i,
        o,
        {
          markerEnd: this.markerHelper.marker(
            "inheritance-end",
            s.stroke
          ),
          ...s
        },
        {
          tension: c,
          closed: u
        }
      );
    };
    return {
      [j.PROCESS]: t,
      [j.SUBPROCESS]: t,
      [j.REF]: t,
      [j.INVALID]: t,
      [j.FEEL]: t,
      [ke.INHERITANCE_TREE]: n,
      [ke.CURVED_REFERENCE]: r
    };
  }
}
N(Hr, "$inject", [
  "eventBus",
  "textRenderer",
  "canvas",
  "defaultRenderer",
  "injector",
  "nodeAdorners",
  "markerHelper",
  "nodeSelection",
  "ruleManager"
]);
class Nr extends Kt {
  constructor(t) {
    super(), this._ruleManager = t;
  }
  /**
   * Defines waypoints for a parent-child connection in a landscape layout style.
   *
   * @param {Object} connection - The connection object representing the link between nodes.
   * @param {Object} [hints] - Additional layout hints.
   * @param {Object} [hints.source] - The source node (parent), containing x, y, width, and height properties.
   * @param {Object} [hints.target] - The target node (child), containing x, y, width, and height properties.
   * @returns {Array<Object>} waypoints - Array of waypoint objects, each containing x and y coordinates.
   *                                      These define the angled path between the source and target nodes.
   */
  layoutConnection(t, n = {}) {
    const r = n.source || t.source, i = n.target || t.target;
    let o;
    const { linkDrawingType: a, endGap: s, curveSag: c, curveShift: u } = this._ruleManager.getFor({
      category: "link",
      type: t.type
    }), l = {
      x: r.x + r.width / 2,
      y: r.y + r.height
    };
    if (a === ke.CURVED_REFERENCE) {
      const { horizontalNodeSpacing: h, verticalNodeSpacing: d } = this._ruleManager.getFor({ category: "landscape" }), S = i.x > r.x, p = {
        x: i.x + i.width / 2 + (S ? -1 : 1) * d * u,
        y: i.y + i.height + s
      }, b = {
        x: (l.x + p.x) / 2,
        y: (l.y + p.y) / 2 + c * h
      };
      o = [l, b, p];
    } else {
      const h = {
        x: i.x + i.width / 2,
        y: i.y - s
      };
      o = [
        l,
        {
          x: l.x,
          y: (l.y + h.y) / 2
        },
        // Vertical midpoint
        {
          x: h.x,
          y: (l.y + h.y) / 2
        },
        // Horizontal to child x-center
        h
      ];
    }
    return o;
  }
}
N(Nr, "$inject", ["ruleManager"]);
const On = 3e3;
class Dr {
  /**
   * Behavior that intercepts elements with 'noHit' property set during
   * create and update hit events.
   *
   * @param {any} eventBus
   */
  constructor(t) {
    t.on("interactionEvents.createHit", On, (n) => {
      const { element: r } = n;
      r.noHit && n.stopPropagation();
    }), t.on("interactionEvents.updateHit", On, (n) => {
      const { element: r } = n;
      r.noHit && n.stopPropagation();
    });
  }
}
Dr.$inject = ["eventBus"];
var Ca = 0, Ta = {
  width: 150,
  height: 50
};
function ka(e) {
  var t = e.split("-");
  return {
    horizontal: t[0] || "center",
    vertical: t[1] || "top"
  };
}
function Oa(e) {
  return he(e) ? R({ top: 0, left: 0, right: 0, bottom: 0 }, e) : {
    top: e,
    left: e,
    right: e,
    bottom: e
  };
}
function Ra(e, t) {
  t.textContent = e;
  var n;
  try {
    var r, i = e === "";
    return t.textContent = i ? "dummy" : e, n = t.getBBox(), r = {
      width: n.width + n.x * 2,
      height: n.height
    }, i && (r.width = 0), r;
  } catch (o) {
    return console.log(o), { width: 0, height: 0 };
  }
}
function $a(e, t, n) {
  for (var r = e.shift(), i = r, o; ; ) {
    if (o = Ra(i, n), o.width = i ? o.width : 0, i === " " || i === "" || o.width < Math.round(t) || i.length < 2)
      return La(e, i, r, o);
    i = Ma(i, o.width, t);
  }
}
function La(e, t, n, r) {
  if (t.length < n.length) {
    var i = n.slice(t.length).trim();
    e.unshift(i);
  }
  return {
    width: r.width,
    height: r.height,
    text: t
  };
}
var Rn = "­";
function Aa(e, t) {
  var n = e.split(/(\s|-|\u00AD)/g), r, i = [], o = 0;
  if (n.length > 1)
    for (; r = n.shift(); )
      if (r.length + o < t)
        i.push(r), o += r.length;
      else {
        (r === "-" || r === Rn) && i.pop();
        break;
      }
  var a = i[i.length - 1];
  return a && a === Rn && (i[i.length - 1] = "-"), i.join("");
}
function Ma(e, t, n) {
  var r = Math.max(e.length * (n / t), 1), i = Aa(e, r);
  return i || (i = e.slice(0, Math.max(Math.round(r - 1), 1))), i;
}
function Pa() {
  var e = document.getElementById("helper-svg");
  return e || (e = F("svg"), M(e, {
    id: "helper-svg"
  }), $e(e, {
    visibility: "hidden",
    position: "fixed",
    width: 0,
    height: 0
  }), document.body.appendChild(e)), e;
}
function ut(e) {
  this._config = R({}, {
    size: Ta,
    padding: Ca,
    style: {},
    align: "center-top"
  }, e || {});
}
ut.prototype.createText = function(e, t) {
  return this.layoutText(e, t).element;
};
ut.prototype.getDimensions = function(e, t) {
  return this.layoutText(e, t).dimensions;
};
ut.prototype.layoutText = function(e, t) {
  var n = R({}, this._config.size, t.box), r = R({}, this._config.style, t.style), i = ka(t.align || this._config.align), o = Oa(t.padding !== void 0 ? t.padding : this._config.padding), a = t.fitBox || !1, s = ja(r), c = e.split(/\u00AD?\r?\n/), u = [], l = n.width - o.left - o.right, h = F("text");
  M(h, { x: 0, y: 0 }), M(h, r);
  var d = Pa();
  for (G(d, h); c.length; )
    u.push($a(c, l, h));
  i.vertical === "middle" && (o.top = o.bottom = 0);
  var S = Ct(u, function(w, A, E) {
    return w + (s || A.height);
  }, 0) + o.top + o.bottom, p = Ct(u, function(w, A, E) {
    return A.width > w ? A.width : w;
  }, 0), b = o.top;
  i.vertical === "middle" && (b += (n.height - S) / 2), b -= (s || u[0].height) / 4;
  var y = F("text");
  M(y, r), v(u, function(w) {
    var A;
    switch (b += s || w.height, i.horizontal) {
      case "left":
        A = o.left;
        break;
      case "right":
        A = (a ? p : l) - o.right - w.width;
        break;
      default:
        A = Math.max(((a ? p : l) - w.width) / 2 + o.left, 0);
    }
    var E = F("tspan");
    M(E, { x: A, y: b }), E.textContent = w.text, G(y, E);
  }), qn(h);
  var T = {
    width: p,
    height: S
  };
  return {
    dimensions: T,
    element: y
  };
};
function ja(e) {
  if ("fontSize" in e && "lineHeight" in e)
    return e.lineHeight * parseInt(e.fontSize, 10);
}
const Ia = 12, Ha = 1.2, Na = 30;
class Br {
  constructor(t) {
    const { fontSize: n, ...r } = t.getFor({
      category: "text"
    }).styles || {}, i = (n || Ia) - 1;
    this._style = {
      fontFamily: "Arial, sans-serif",
      fontSize: i,
      fontWeight: "normal",
      lineHeight: Ha,
      ...r || {}
    }, this.textUtil = new ut({
      style: this._style
    });
  }
  /**
   * Get the new bounds of an externally rendered,
   * layouted label.
   *
   * @param {any} bounds
   * @param {string} text
   *
   * @return {any}
   */
  getExternalLabelBounds(t, n) {
    const r = this.textUtil.getDimensions(n, {
      box: {
        width: 90,
        height: 30,
        x: t.width / 2 + t.x,
        y: t.height / 2 + t.y
      },
      style: this._style
    });
    return {
      x: Math.round(t.x + t.width / 2 - r.width / 2),
      y: Math.round(t.y),
      width: Math.ceil(r.width),
      height: Math.ceil(r.height)
    };
  }
  /**
   * Get the new bounds of text annotation.
   *
   * @param bounds
   * @param {string} text
   *
   * @return {any}
   */
  getTextAnnotationBounds(t, n) {
    const r = this.textUtil.getDimensions(n, {
      box: t,
      style: this._style,
      align: "left-top",
      padding: 5
    });
    return {
      x: t.x,
      y: t.y,
      width: t.width,
      height: Math.max(
        Na,
        Math.round(r.height)
      )
    };
  }
  /**
   * Create a layouted text element.
   *
   * @param {string} text
   * @param {Object} [options]
   *
   * @return {SVGElement} rendered text
   */
  createText(t, n) {
    return this.textUtil.createText(t, n || {});
  }
}
N(Br, "$inject", ["ruleManager"]);
class Fr {
  constructor(t, n) {
    this.rendererId = jr(), this.canvas = t, this.ruleManager = n, this.markers = {};
  }
  marker(t, n = "black", r = n) {
    const i = `${t}#-${this._colorEscape(n)}-${this._colorEscape(r)}-${this.rendererId}`;
    return this.markers[i] || this.createMarker(i, t, n, r), `url(#${i})`;
  }
  addMarker(t, n) {
    const r = {
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeDasharray: "none",
      ...n.attrs
    }, i = n.ref || { x: 0, y: 0 }, o = n.scale || 1;
    r.strokeDasharray === "none" && (r.strokeDasharray = [1e4, 1]);
    const a = F("marker");
    M(n.element, r), G(a, n.element), M(a, {
      id: t,
      viewBox: "0 0 20 20",
      refX: i.x,
      refY: i.y,
      markerWidth: 20 * o,
      markerHeight: 20 * o,
      orient: "auto"
    });
    let s = ie("defs", this.canvas._svg);
    s || (s = F("defs"), G(this.canvas._svg, s)), G(s, a), this.markers[t] = a;
  }
  createMarker(t, n, r, i) {
    const { scale: o } = this.ruleManager.getFor({
      category: "marker"
    }).styles, a = {
      d: "M 3 5 L 11 10 L 3 15",
      ref: { x: 8, y: 10 },
      scale: o,
      attrs: {
        strokeWidth: 1.5,
        stroke: "none",
        fill: r
      }
    }, c = {
      "inheritance-end": a,
      "reference-end": {
        ...a,
        scale: o * 0.8
      }
    }[n];
    if (!c) return;
    const u = F(c.type || "path");
    M(u, c), this.addMarker(t, {
      element: u,
      attrs: { fill: r, stroke: i, strokeWidth: 1.5, ...c.attrs },
      ref: c.ref,
      scale: c.scale
    });
  }
  _colorEscape(t) {
    return t.replace(/[^0-9a-zA-Z]+/g, "_");
  }
}
N(Fr, "$inject", ["canvas", "ruleManager"]);
function Da(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var re = Da;
const Ba = /* @__PURE__ */ qt(re);
function Fa() {
  this.__data__ = [], this.size = 0;
}
var Ua = Fa;
function za(e, t) {
  return e === t || e !== e && t !== t;
}
var ht = za, Ga = ht;
function Va(e, t) {
  for (var n = e.length; n--; )
    if (Ga(e[n][0], t))
      return n;
  return -1;
}
var dt = Va, Wa = dt, Ka = Array.prototype, Ya = Ka.splice;
function qa(e) {
  var t = this.__data__, n = Wa(t, e);
  if (n < 0)
    return !1;
  var r = t.length - 1;
  return n == r ? t.pop() : Ya.call(t, n, 1), --this.size, !0;
}
var Za = qa, Xa = dt;
function Ja(e) {
  var t = this.__data__, n = Xa(t, e);
  return n < 0 ? void 0 : t[n][1];
}
var Qa = Ja, es = dt;
function ts(e) {
  return es(this.__data__, e) > -1;
}
var ns = ts, rs = dt;
function is(e, t) {
  var n = this.__data__, r = rs(n, e);
  return r < 0 ? (++this.size, n.push([e, t])) : n[r][1] = t, this;
}
var os = is, as = Ua, ss = Za, cs = Qa, ls = ns, us = os;
function ve(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
ve.prototype.clear = as;
ve.prototype.delete = ss;
ve.prototype.get = cs;
ve.prototype.has = ls;
ve.prototype.set = us;
var ft = ve, hs = ft;
function ds() {
  this.__data__ = new hs(), this.size = 0;
}
var fs = ds;
function ps(e) {
  var t = this.__data__, n = t.delete(e);
  return this.size = t.size, n;
}
var gs = ps;
function ys(e) {
  return this.__data__.get(e);
}
var vs = ys;
function _s(e) {
  return this.__data__.has(e);
}
var ms = _s, Ss = Be, Es = re, bs = "[object AsyncFunction]", ws = "[object Function]", xs = "[object GeneratorFunction]", Cs = "[object Proxy]";
function Ts(e) {
  if (!Es(e))
    return !1;
  var t = Ss(e);
  return t == ws || t == xs || t == bs || t == Cs;
}
var Jt = Ts, ks = ge, Os = ks["__core-js_shared__"], Rs = Os, Et = Rs, $n = function() {
  var e = /[^.]+$/.exec(Et && Et.keys && Et.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function $s(e) {
  return !!$n && $n in e;
}
var Ls = $s, As = Function.prototype, Ms = As.toString;
function Ps(e) {
  if (e != null) {
    try {
      return Ms.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var js = Ps, Is = Jt, Hs = Ls, Ns = re, Ds = js, Bs = /[\\^$.*+?()[\]{}|]/g, Fs = /^\[object .+?Constructor\]$/, Us = Function.prototype, zs = Object.prototype, Gs = Us.toString, Vs = zs.hasOwnProperty, Ws = RegExp(
  "^" + Gs.call(Vs).replace(Bs, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function Ks(e) {
  if (!Ns(e) || Hs(e))
    return !1;
  var t = Is(e) ? Ws : Fs;
  return t.test(Ds(e));
}
var Ys = Ks;
function qs(e, t) {
  return e == null ? void 0 : e[t];
}
var Zs = qs, Xs = Ys, Js = Zs;
function Qs(e, t) {
  var n = Js(e, t);
  return Xs(n) ? n : void 0;
}
var Qt = Qs, ec = Qt, tc = ge, nc = ec(tc, "Map"), Ur = nc, rc = Qt, ic = rc(Object, "create"), pt = ic, Ln = pt;
function oc() {
  this.__data__ = Ln ? Ln(null) : {}, this.size = 0;
}
var ac = oc;
function sc(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var cc = sc, lc = pt, uc = "__lodash_hash_undefined__", hc = Object.prototype, dc = hc.hasOwnProperty;
function fc(e) {
  var t = this.__data__;
  if (lc) {
    var n = t[e];
    return n === uc ? void 0 : n;
  }
  return dc.call(t, e) ? t[e] : void 0;
}
var pc = fc, gc = pt, yc = Object.prototype, vc = yc.hasOwnProperty;
function _c(e) {
  var t = this.__data__;
  return gc ? t[e] !== void 0 : vc.call(t, e);
}
var mc = _c, Sc = pt, Ec = "__lodash_hash_undefined__";
function bc(e, t) {
  var n = this.__data__;
  return this.size += this.has(e) ? 0 : 1, n[e] = Sc && t === void 0 ? Ec : t, this;
}
var wc = bc, xc = ac, Cc = cc, Tc = pc, kc = mc, Oc = wc;
function _e(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
_e.prototype.clear = xc;
_e.prototype.delete = Cc;
_e.prototype.get = Tc;
_e.prototype.has = kc;
_e.prototype.set = Oc;
var Rc = _e, An = Rc, $c = ft, Lc = Ur;
function Ac() {
  this.size = 0, this.__data__ = {
    hash: new An(),
    map: new (Lc || $c)(),
    string: new An()
  };
}
var Mc = Ac;
function Pc(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
var jc = Pc, Ic = jc;
function Hc(e, t) {
  var n = e.__data__;
  return Ic(t) ? n[typeof t == "string" ? "string" : "hash"] : n.map;
}
var gt = Hc, Nc = gt;
function Dc(e) {
  var t = Nc(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
var Bc = Dc, Fc = gt;
function Uc(e) {
  return Fc(this, e).get(e);
}
var zc = Uc, Gc = gt;
function Vc(e) {
  return Gc(this, e).has(e);
}
var Wc = Vc, Kc = gt;
function Yc(e, t) {
  var n = Kc(this, e), r = n.size;
  return n.set(e, t), this.size += n.size == r ? 0 : 1, this;
}
var qc = Yc, Zc = Mc, Xc = Bc, Jc = zc, Qc = Wc, el = qc;
function me(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
me.prototype.clear = Zc;
me.prototype.delete = Xc;
me.prototype.get = Jc;
me.prototype.has = Qc;
me.prototype.set = el;
var tl = me, nl = ft, rl = Ur, il = tl, ol = 200;
function al(e, t) {
  var n = this.__data__;
  if (n instanceof nl) {
    var r = n.__data__;
    if (!rl || r.length < ol - 1)
      return r.push([e, t]), this.size = ++n.size, this;
    n = this.__data__ = new il(r);
  }
  return n.set(e, t), this.size = n.size, this;
}
var sl = al, cl = ft, ll = fs, ul = gs, hl = vs, dl = ms, fl = sl;
function Se(e) {
  var t = this.__data__ = new cl(e);
  this.size = t.size;
}
Se.prototype.clear = ll;
Se.prototype.delete = ul;
Se.prototype.get = hl;
Se.prototype.has = dl;
Se.prototype.set = fl;
var pl = Se, gl = Qt, yl = function() {
  try {
    var e = gl(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}(), zr = yl, Mn = zr;
function vl(e, t, n) {
  t == "__proto__" && Mn ? Mn(e, t, {
    configurable: !0,
    enumerable: !0,
    value: n,
    writable: !0
  }) : e[t] = n;
}
var en = vl, _l = en, ml = ht;
function Sl(e, t, n) {
  (n !== void 0 && !ml(e[t], n) || n === void 0 && !(t in e)) && _l(e, t, n);
}
var Gr = Sl;
function El(e) {
  return function(t, n, r) {
    for (var i = -1, o = Object(t), a = r(t), s = a.length; s--; ) {
      var c = a[e ? s : ++i];
      if (n(o[c], c, o) === !1)
        break;
    }
    return t;
  };
}
var bl = El, wl = bl, xl = wl(), Cl = xl, Ye = { exports: {} };
Ye.exports;
(function(e, t) {
  var n = ge, r = t && !t.nodeType && t, i = r && !0 && e && !e.nodeType && e, o = i && i.exports === r, a = o ? n.Buffer : void 0, s = a ? a.allocUnsafe : void 0;
  function c(u, l) {
    if (l)
      return u.slice();
    var h = u.length, d = s ? s(h) : new u.constructor(h);
    return u.copy(d), d;
  }
  e.exports = c;
})(Ye, Ye.exports);
var Tl = Ye.exports, kl = ge, Ol = kl.Uint8Array, Rl = Ol, Pn = Rl;
function $l(e) {
  var t = new e.constructor(e.byteLength);
  return new Pn(t).set(new Pn(e)), t;
}
var Ll = $l, Al = Ll;
function Ml(e, t) {
  var n = t ? Al(e.buffer) : e.buffer;
  return new e.constructor(n, e.byteOffset, e.length);
}
var Pl = Ml;
function jl(e, t) {
  var n = -1, r = e.length;
  for (t || (t = Array(r)); ++n < r; )
    t[n] = e[n];
  return t;
}
var Il = jl, Hl = re, jn = Object.create, Nl = /* @__PURE__ */ function() {
  function e() {
  }
  return function(t) {
    if (!Hl(t))
      return {};
    if (jn)
      return jn(t);
    e.prototype = t;
    var n = new e();
    return e.prototype = void 0, n;
  };
}(), Dl = Nl;
function Bl(e, t) {
  return function(n) {
    return e(t(n));
  };
}
var Fl = Bl, Ul = Fl, zl = Ul(Object.getPrototypeOf, Object), Vr = zl, Gl = Object.prototype;
function Vl(e) {
  var t = e && e.constructor, n = typeof t == "function" && t.prototype || Gl;
  return e === n;
}
var Wr = Vl, Wl = Dl, Kl = Vr, Yl = Wr;
function ql(e) {
  return typeof e.constructor == "function" && !Yl(e) ? Wl(Kl(e)) : {};
}
var Zl = ql, Xl = Be, Jl = ye, Ql = "[object Arguments]";
function eu(e) {
  return Jl(e) && Xl(e) == Ql;
}
var tu = eu, In = tu, nu = ye, Kr = Object.prototype, ru = Kr.hasOwnProperty, iu = Kr.propertyIsEnumerable, ou = In(/* @__PURE__ */ function() {
  return arguments;
}()) ? In : function(e) {
  return nu(e) && ru.call(e, "callee") && !iu.call(e, "callee");
}, Yr = ou, au = 9007199254740991;
function su(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= au;
}
var qr = su, cu = Jt, lu = qr;
function uu(e) {
  return e != null && lu(e.length) && !cu(e);
}
var tn = uu, hu = tn, du = ye;
function fu(e) {
  return du(e) && hu(e);
}
var pu = fu, qe = { exports: {} };
function gu() {
  return !1;
}
var yu = gu;
qe.exports;
(function(e, t) {
  var n = ge, r = yu, i = t && !t.nodeType && t, o = i && !0 && e && !e.nodeType && e, a = o && o.exports === i, s = a ? n.Buffer : void 0, c = s ? s.isBuffer : void 0, u = c || r;
  e.exports = u;
})(qe, qe.exports);
var Zr = qe.exports, vu = Be, _u = Vr, mu = ye, Su = "[object Object]", Eu = Function.prototype, bu = Object.prototype, Xr = Eu.toString, wu = bu.hasOwnProperty, xu = Xr.call(Object);
function Cu(e) {
  if (!mu(e) || vu(e) != Su)
    return !1;
  var t = _u(e);
  if (t === null)
    return !0;
  var n = wu.call(t, "constructor") && t.constructor;
  return typeof n == "function" && n instanceof n && Xr.call(n) == xu;
}
var Tu = Cu, ku = Be, Ou = qr, Ru = ye, $u = "[object Arguments]", Lu = "[object Array]", Au = "[object Boolean]", Mu = "[object Date]", Pu = "[object Error]", ju = "[object Function]", Iu = "[object Map]", Hu = "[object Number]", Nu = "[object Object]", Du = "[object RegExp]", Bu = "[object Set]", Fu = "[object String]", Uu = "[object WeakMap]", zu = "[object ArrayBuffer]", Gu = "[object DataView]", Vu = "[object Float32Array]", Wu = "[object Float64Array]", Ku = "[object Int8Array]", Yu = "[object Int16Array]", qu = "[object Int32Array]", Zu = "[object Uint8Array]", Xu = "[object Uint8ClampedArray]", Ju = "[object Uint16Array]", Qu = "[object Uint32Array]", O = {};
O[Vu] = O[Wu] = O[Ku] = O[Yu] = O[qu] = O[Zu] = O[Xu] = O[Ju] = O[Qu] = !0;
O[$u] = O[Lu] = O[zu] = O[Au] = O[Gu] = O[Mu] = O[Pu] = O[ju] = O[Iu] = O[Hu] = O[Nu] = O[Du] = O[Bu] = O[Fu] = O[Uu] = !1;
function eh(e) {
  return Ru(e) && Ou(e.length) && !!O[ku(e)];
}
var th = eh;
function nh(e) {
  return function(t) {
    return e(t);
  };
}
var rh = nh, Ze = { exports: {} };
Ze.exports;
(function(e, t) {
  var n = Ar, r = t && !t.nodeType && t, i = r && !0 && e && !e.nodeType && e, o = i && i.exports === r, a = o && n.process, s = function() {
    try {
      var c = i && i.require && i.require("util").types;
      return c || a && a.binding && a.binding("util");
    } catch {
    }
  }();
  e.exports = s;
})(Ze, Ze.exports);
var ih = Ze.exports, oh = th, ah = rh, Hn = ih, Nn = Hn && Hn.isTypedArray, sh = Nn ? ah(Nn) : oh, Jr = sh;
function ch(e, t) {
  if (!(t === "constructor" && typeof e[t] == "function") && t != "__proto__")
    return e[t];
}
var Qr = ch, lh = en, uh = ht, hh = Object.prototype, dh = hh.hasOwnProperty;
function fh(e, t, n) {
  var r = e[t];
  (!(dh.call(e, t) && uh(r, n)) || n === void 0 && !(t in e)) && lh(e, t, n);
}
var ph = fh, gh = ph, yh = en;
function vh(e, t, n, r) {
  var i = !n;
  n || (n = {});
  for (var o = -1, a = t.length; ++o < a; ) {
    var s = t[o], c = r ? r(n[s], e[s], s, n, e) : void 0;
    c === void 0 && (c = e[s]), i ? yh(n, s, c) : gh(n, s, c);
  }
  return n;
}
var _h = vh;
function mh(e, t) {
  for (var n = -1, r = Array(e); ++n < e; )
    r[n] = t(n);
  return r;
}
var Sh = mh, Eh = 9007199254740991, bh = /^(?:0|[1-9]\d*)$/;
function wh(e, t) {
  var n = typeof e;
  return t = t ?? Eh, !!t && (n == "number" || n != "symbol" && bh.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
var ei = wh, xh = Sh, Ch = Yr, Th = Xt, kh = Zr, Oh = ei, Rh = Jr, $h = Object.prototype, Lh = $h.hasOwnProperty;
function Ah(e, t) {
  var n = Th(e), r = !n && Ch(e), i = !n && !r && kh(e), o = !n && !r && !i && Rh(e), a = n || r || i || o, s = a ? xh(e.length, String) : [], c = s.length;
  for (var u in e)
    (t || Lh.call(e, u)) && !(a && // Safari 9 has enumerable `arguments.length` in strict mode.
    (u == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    i && (u == "offset" || u == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    o && (u == "buffer" || u == "byteLength" || u == "byteOffset") || // Skip index properties.
    Oh(u, c))) && s.push(u);
  return s;
}
var Mh = Ah;
function Ph(e) {
  var t = [];
  if (e != null)
    for (var n in Object(e))
      t.push(n);
  return t;
}
var jh = Ph, Ih = re, Hh = Wr, Nh = jh, Dh = Object.prototype, Bh = Dh.hasOwnProperty;
function Fh(e) {
  if (!Ih(e))
    return Nh(e);
  var t = Hh(e), n = [];
  for (var r in e)
    r == "constructor" && (t || !Bh.call(e, r)) || n.push(r);
  return n;
}
var Uh = Fh, zh = Mh, Gh = Uh, Vh = tn;
function Wh(e) {
  return Vh(e) ? zh(e, !0) : Gh(e);
}
var ti = Wh, Kh = _h, Yh = ti;
function qh(e) {
  return Kh(e, Yh(e));
}
var Zh = qh, Dn = Gr, Xh = Tl, Jh = Pl, Qh = Il, ed = Zl, Bn = Yr, Fn = Xt, td = pu, nd = Zr, rd = Jt, id = re, od = Tu, ad = Jr, Un = Qr, sd = Zh;
function cd(e, t, n, r, i, o, a) {
  var s = Un(e, n), c = Un(t, n), u = a.get(c);
  if (u) {
    Dn(e, n, u);
    return;
  }
  var l = o ? o(s, c, n + "", e, t, a) : void 0, h = l === void 0;
  if (h) {
    var d = Fn(c), S = !d && nd(c), p = !d && !S && ad(c);
    l = c, d || S || p ? Fn(s) ? l = s : td(s) ? l = Qh(s) : S ? (h = !1, l = Xh(c, !0)) : p ? (h = !1, l = Jh(c, !0)) : l = [] : od(c) || Bn(c) ? (l = s, Bn(s) ? l = sd(s) : (!id(s) || rd(s)) && (l = ed(c))) : h = !1;
  }
  h && (a.set(c, l), i(l, c, r, o, a), a.delete(c)), Dn(e, n, l);
}
var ld = cd, ud = pl, hd = Gr, dd = Cl, fd = ld, pd = re, gd = ti, yd = Qr;
function ni(e, t, n, r, i) {
  e !== t && dd(t, function(o, a) {
    if (i || (i = new ud()), pd(o))
      fd(e, t, a, n, ni, r, i);
    else {
      var s = r ? r(yd(e, a), o, a + "", e, t, i) : void 0;
      s === void 0 && (s = o), hd(e, a, s);
    }
  }, gd);
}
var vd = ni;
function _d(e) {
  return e;
}
var ri = _d;
function md(e, t, n) {
  switch (n.length) {
    case 0:
      return e.call(t);
    case 1:
      return e.call(t, n[0]);
    case 2:
      return e.call(t, n[0], n[1]);
    case 3:
      return e.call(t, n[0], n[1], n[2]);
  }
  return e.apply(t, n);
}
var Sd = md, Ed = Sd, zn = Math.max;
function bd(e, t, n) {
  return t = zn(t === void 0 ? e.length - 1 : t, 0), function() {
    for (var r = arguments, i = -1, o = zn(r.length - t, 0), a = Array(o); ++i < o; )
      a[i] = r[t + i];
    i = -1;
    for (var s = Array(t + 1); ++i < t; )
      s[i] = r[i];
    return s[t] = n(a), Ed(e, this, s);
  };
}
var wd = bd;
function xd(e) {
  return function() {
    return e;
  };
}
var Cd = xd, Td = Cd, Gn = zr, kd = ri, Od = Gn ? function(e, t) {
  return Gn(e, "toString", {
    configurable: !0,
    enumerable: !1,
    value: Td(t),
    writable: !0
  });
} : kd, Rd = Od, $d = 800, Ld = 16, Ad = Date.now;
function Md(e) {
  var t = 0, n = 0;
  return function() {
    var r = Ad(), i = Ld - (r - n);
    if (n = r, i > 0) {
      if (++t >= $d)
        return arguments[0];
    } else
      t = 0;
    return e.apply(void 0, arguments);
  };
}
var Pd = Md, jd = Rd, Id = Pd, Hd = Id(jd), Nd = Hd, Dd = ri, Bd = wd, Fd = Nd;
function Ud(e, t) {
  return Fd(Bd(e, t, Dd), e + "");
}
var zd = Ud, Gd = ht, Vd = tn, Wd = ei, Kd = re;
function Yd(e, t, n) {
  if (!Kd(n))
    return !1;
  var r = typeof t;
  return (r == "number" ? Vd(n) && Wd(t, n.length) : r == "string" && t in n) ? Gd(n[t], e) : !1;
}
var qd = Yd, Zd = zd, Xd = qd;
function Jd(e) {
  return Zd(function(t, n) {
    var r = -1, i = n.length, o = i > 1 ? n[i - 1] : void 0, a = i > 2 ? n[2] : void 0;
    for (o = e.length > 3 && typeof o == "function" ? (i--, o) : void 0, a && Xd(n[0], n[1], a) && (o = i < 3 ? void 0 : o, i = 1), t = Object(t); ++r < i; ) {
      var s = n[r];
      s && e(t, s, r, o);
    }
    return t;
  });
}
var Qd = Jd, ef = vd, tf = Qd, nf = tf(function(e, t, n, r) {
  ef(e, t, n, r);
}), rf = nf;
const of = /* @__PURE__ */ qt(rf), af = (e) => {
  const t = (n, r) => {
    if (Array.isArray(n))
      return n.concat(r);
  };
  return e.reduce(
    (n, r) => of(n, r.apply, t),
    {}
  );
}, Oe = (e) => Array.isArray(e) ? e : [e], ii = (e) => Object.fromEntries(
  Object.entries(e).map(([t, n]) => [t, Oe(n)])
);
class C {
  /**
   * Add rules based on criteria.
   * @param {Array|Object} criteria - Array of criteria or a single criterion object.
   * @returns {Object} - Chainable object with an `apply` method.
   */
  static for(t) {
    if (!t)
      throw new Error("Criteria must be provided.");
    return t = Oe(t), {
      apply(n) {
        if (!an(n))
          throw new Error("Rule must apply an object.");
        return t.forEach((r) => {
          if (!an(r))
            throw new Error("Rule criterion must be an object.");
        }), {
          criteria: t.map(ii),
          apply: n
        };
      },
      applyStyles(n) {
        return this.apply({ styles: n });
      },
      applyAdorners(n) {
        return Array.isArray(n) || (n = Oe(n)), this.apply({ adorners: { definitions: n } });
      }
    };
  }
  /**
   * Shortcuts for defining rules for specific categories.
   */
  static forLandscape(t = {}) {
    return C.for({ ...t, category: "landscape" });
  }
  static forNodes(t = {}) {
    return C.for({ ...t, category: "node" });
  }
  static forLinks(t = {}) {
    return C.for({ ...t, category: "link" });
  }
  static forLabels(t = {}) {
    return C.for({ ...t, category: "label" });
  }
  static forMarkers(t = {}) {
    return C.for({ ...t, category: "marker" });
  }
  static forAdorners(t = {}) {
    return C.for({ ...t, category: "adorner" });
  }
}
const sf = [
  C.forNodes().applyStyles({
    width: 100,
    height: 50,
    fill: "white",
    stroke: "var(--stroke-default)",
    strokeWidth: "var(--stroke-width-default)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    rx: 10,
    ry: 10
  }),
  C.forNodes({ type: j.PROCESS }).applyStyles({
    stroke: "var(--stroke-process)"
  }),
  C.forNodes({ type: j.SUBPROCESS }).applyStyles({
    stroke: "var(--stroke-subprocess)",
    strokeDasharray: 2
  }),
  C.forLandscape().apply({
    horizontalNodeSpacing: 120,
    verticalNodeSpacing: 100
  }),
  C.forLinks().apply({
    linkDrawingType: ke.INHERITANCE_TREE,
    styles: {
      stroke: "var(--stroke-association)",
      strokeWidth: "var(--stroke-width-association)"
    },
    endGap: 6,
    tension: 3.2,
    closed: !1
  }),
  C.forLinks({ type: z.REF }).apply({
    linkDrawingType: ke.CURVED_REFERENCE,
    curveSag: 0.65,
    curveShift: 0.15
  }),
  C.forMarkers().applyStyles({
    scale: 0.5
  }),
  C.forLabels().applyStyles({
    padding: 5,
    align: "center-middle",
    fill: "var(--fill-text)"
  }),
  C.forLabels({ type: $t.NODE_LINK_LABEL }).applyStyles({
    fill: "var(--fill-link)",
    cursor: "pointer",
    textDecoration: "underline"
  }),
  C.forLabels({ type: j.REF }).applyStyles({
    fill: "var(--fill-light-text)"
  }),
  C.forAdorners().apply({
    gap: 5
  }),
  C.for({ state: "selected" }).applyStyles({
    stroke: "var(--stroke-selected-element)"
  })
];
class oi {
  constructor(t, n = []) {
    const { useDefaultRules: r = !0 } = t || {};
    this.rules = r ? [...sf, ...n] : n;
  }
  /**
   * Clear all rules.
   */
  clearRules() {
    this.rules = [];
  }
  /**
   * Retrieve styles and adorners based on matching criteria.
   * @param {Object} criterion - Criterion to match against stored rules.
   * @returns {Object} - Combined styles and adorners from matching rules.
   */
  getFor(t) {
    if (!Ba(t))
      throw new Error("Rule criterion must be an object.");
    t = ii(t);
    const n = this.rules.filter(
      (r) => this.matchCriteria(r.criteria, t)
    );
    return af(n);
  }
  /**
   * Check if a rule matches the given criteria.
   * @param {Object} ruleCriteria - Rule criteria.
   * @param {Object} queryCriteria - Query criteria.
   * @returns {boolean} - True if the rule matches.
   */
  matchCriteria(t, n) {
    return t.some(
      (r) => Object.entries(r).every(([i, o]) => {
        const a = n[i];
        if (!a)
          return !1;
        const s = Oe(o);
        return Oe(a).some(
          (u) => s.includes(u)
        );
      })
    );
  }
}
N(oi, "$inject", ["config.ruleManager", "config.rules"]);
const cf = {
  __init__: [
    "layouter",
    "landscapeManager",
    "landscapeRenderManager",
    "landscapeRenderer",
    "nodeAdorners",
    "nodeSelection",
    "noHitBehavior",
    "markerHelper",
    "ruleManager",
    [
      "defaultRenderer",
      function(e) {
        e.CONNECTION_STYLE = {
          fill: "none",
          strokeWidth: 2,
          stroke: "#000"
        }, e.SHAPE_STYLE = {
          fill: "white",
          stroke: "#000",
          strokeWidth: 2
        }, e.FRAME_STYLE = {
          fill: "none",
          stroke: "#000",
          strokeDasharray: 4,
          strokeWidth: 2
        };
      }
    ]
  ],
  elementFactory: ["type", Lr],
  layouter: ["type", Nr],
  landscapeManager: ["type", $r],
  landscapeRenderManager: ["type", Ir],
  landscapeRenderer: ["type", Hr],
  noHitBehavior: ["type", Dr],
  textRenderer: ["type", Br],
  markerHelper: ["type", Fr],
  ruleManager: ["type", oi]
}, lf = 5;
class ai {
  constructor(t, n) {
    this.config = t, this.ruleManager = n;
  }
  getApplicableAdorners(t) {
    const n = [], r = this.ruleManager.getFor({
      category: "node",
      type: t.type
    }).adorners || {}, { definitions: i = [] } = r;
    return n.push(...i), n;
  }
  renderAdorners(t, n) {
    const r = this.getApplicableAdorners(t), i = {};
    r.forEach((o) => {
      const {
        position: a,
        content: s = "",
        styles: c = {}
      } = o.getAdornerInfo(t), { gap: u, ...l } = this.ruleManager.getFor({
        category: "adorner"
      }), h = { ...l, ...c }, d = s.trim().startsWith("<svg"), S = document.createElementNS(
        "http://www.w3.org/2000/svg",
        "g"
      );
      S.setAttribute("class", "pl-node-adorner-group");
      const { x: p, y: b } = this._calculatePosition(t, {
        position: a,
        positionOffsets: i,
        gap: u,
        isSVG: d,
        content: s,
        styles: h
      });
      d ? this.appendSVGContent(
        S,
        s,
        p,
        b,
        h
      ) : this.appendTextContent(
        S,
        s,
        p,
        b,
        h
      ), n.appendChild(S);
    });
  }
  _calculatePosition(t, { position: n, positionOffsets: r, gap: i, isSVG: o, content: a, styles: s }) {
    [
      "top-left",
      "top-right",
      "bottom-left",
      "bottom-right"
    ].includes(n) || (n = "bottom-right"), r[n] = r[n] || {
      xOffset: i
    };
    const u = this.measureContentSize(a, o, s), l = o ? this._getBasePosition(n, t, u) : this._getBaseTextPosition(n, t, u), h = r[n].xOffset;
    r[n].xOffset += u.width + i;
    const d = i;
    return {
      x: n.includes("right") ? l.x - h : l.x + h,
      y: n.includes("bottom") ? l.y - d : l.y + d
    };
  }
  _getBaseTextPosition(t, n, r) {
    const i = t.includes("left") ? 0 : n.width - r.width, o = t.includes("bottom") ? n.height : r.height - lf;
    return { x: i, y: o };
  }
  _getBasePosition(t, n, r) {
    const i = t.includes("left") ? 0 : n.width - r.width, o = t.includes("top") ? 0 : n.height - r.height;
    return { x: i, y: o };
  }
  measureContentSize(t, n, r) {
    if (!n)
      return ba(t, r);
    const o = new DOMParser().parseFromString(
      t,
      "image/svg+xml"
    ).documentElement, a = parseFloat(o.getAttribute("width") || "20"), s = parseFloat(o.getAttribute("height") || "20");
    return { width: a, height: s };
  }
  appendSVGContent(t, n, r, i, { _attr: o = {}, ...a } = {}) {
    const c = new DOMParser().parseFromString(
      n,
      "image/svg+xml"
    ).documentElement;
    Lt(c, {
      _attr: {
        ...o,
        x: r,
        y: i
      },
      ...a
    }), t.appendChild(c);
  }
  appendTextContent(t, n, r, i, { _attr: o = {}, ...a } = {}) {
    const s = document.createElementNS(
      "http://www.w3.org/2000/svg",
      "text"
    );
    s.textContent = n, Lt(s, {
      _attr: {
        ...o,
        x: r,
        y: i,
        class: "pl-node-adorner"
      },
      ...a
    }), t.appendChild(s);
  }
}
N(ai, "$inject", ["config.nodeAdorners", "ruleManager"]);
const uf = {
  __init__: ["nodeAdorners"],
  nodeAdorners: ["type", ai]
};
class si {
  constructor(t, n, r, i) {
    this._eventBus = t, this._canvas = n, this._markerHelper = r, this.ruleManager = i, this._previousStyles = /* @__PURE__ */ new Map(), this._connectionMarkers = /* @__PURE__ */ new Map(), this._eventBus.on("selection.changed", (o) => {
      const a = Array.from(this._previousStyles.keys()), s = o.newSelection;
      this.resetStyles(a), s.forEach((c) => {
        this.applyStyles(c);
      });
    });
  }
  resetStyles(t) {
    t.forEach((n) => {
      const r = this._previousStyles.get(n);
      if (r) {
        const i = this._canvas.getGraphics(n);
        if (i) {
          const o = this._getRectElement(i);
          if (o) {
            const { nodeStyles: a } = r;
            this._applyNodeStyles(o, a);
          }
          r.linkStyles && r.linkStyles.forEach((a, s) => {
            const c = this._canvas.getGraphics(s);
            if (c) {
              const u = this._getLinkElement(c);
              if (u) {
                const l = this._connectionMarkers.get(s);
                l && (u.style.markerEnd = l, this._connectionMarkers.delete(s)), this._applyConnectionStyles(u, a);
              }
            }
          });
        }
        this._previousStyles.delete(n);
      }
    });
  }
  applyStyles(t) {
    const n = this._canvas.getGraphics(t);
    if (n) {
      const r = this._getRectElement(n), i = /* @__PURE__ */ new Map();
      if (r) {
        const o = this._extractNodeStyles(r), { styles: a = {} } = this.ruleManager.getFor({
          category: "node",
          type: t.type,
          state: "selected"
        });
        this._applyNodeStyles(r, a || {}), this._previousStyles.set(t, {
          nodeStyles: o,
          linkStyles: i
        });
      }
      t.outgoing && t.outgoing.forEach((o) => {
        const a = this._canvas.getGraphics(o);
        if (a) {
          const s = this._getLinkElement(a);
          if (s) {
            const c = this._extractLinkStyles(s);
            i.set(o, c);
            const { styles: u = {} } = this.ruleManager.getFor({
              category: "link",
              type: o.type,
              state: "selected"
            }), l = s.style.markerEnd, h = this._extractMarkerType(l), d = this._markerHelper.marker(
              h,
              u.stroke
            );
            s.style.markerEnd = d, this._connectionMarkers.set(o, l), this._applyConnectionStyles(s, u);
          }
        }
      }), this._previousStyles.has(t) && (this._previousStyles.get(t).linkStyles = i);
    }
  }
  _extractNodeStyles(t) {
    return {
      stroke: t.style.stroke || "",
      strokeWidth: t.style.strokeWidth || ""
    };
  }
  _extractLinkStyles(t) {
    return {
      stroke: t.style.stroke || "",
      strokeWidth: t.style.strokeWidth || ""
    };
  }
  _extractMarkerType(t) {
    const n = /#(.*?)#/, r = t.match(n);
    return r ? r[1] : "inheritance-end";
  }
  _applyNodeStyles(t, n) {
    t.style.stroke = n.stroke, t.style.strokeWidth = n.strokeWidth;
  }
  _applyConnectionStyles(t, n) {
    t.style.stroke = n.stroke, t.style.strokeWidth = n.strokeWidth;
  }
  _getRectElement(t) {
    return t.querySelector(".djs-visual rect");
  }
  _getLinkElement(t) {
    return t.querySelector(".djs-visual path");
  }
}
N(si, "$inject", ["eventBus", "canvas", "markerHelper", "ruleManager"]);
const hf = {
  __init__: ["nodeSelection"],
  nodeSelection: ["type", si]
};
class ci {
  /**
   * @param {Canvas} canvas
   * @param {EventBus} eventBus
   */
  constructor(t, n) {
    this._eventBus = t, this._canvas = n;
  }
  /**
   * Replace CSS custom properties (variables) with their computed values for export.
   *
   * @param {SVGElement} svgRoot - The root SVG element to resolve variables in.
   * @param {Element} referenceEl - The element used to compute styles from (should be in the DOM).
   */
  _resolveCSSVars(t, n = document.documentElement) {
    const r = t.querySelectorAll("[style]"), i = getComputedStyle(n);
    r.forEach((o) => {
      const a = o.getAttribute("style");
      if (!a || !a.includes("var(")) return;
      const s = a.replace(
        /var\((--[^)]+)\)/g,
        (c, u) => {
          const l = i.getPropertyValue(u);
          return (l == null ? void 0 : l.trim()) || "initial";
        }
      );
      o.setAttribute("style", s);
    });
  }
  /**
   * Export the current diagram as an SVG string with all CSS variables resolved.
   *
   * @returns {Promise<{ svg: string }>} The final SVG string.
   */
  async saveSVG() {
    this._eventBus.fire("saveSVG.start");
    try {
      const t = this._canvas.getContainer().querySelector("svg"), n = t.cloneNode(!0);
      if (!(n instanceof SVGGraphicsElement))
        throw new Error("Cloned node is not an SVGGraphicsElement.");
      const r = n, i = document.createElement("div");
      Object.assign(i.style, {
        position: "absolute",
        visibility: "hidden",
        pointerEvents: "none",
        width: "0",
        height: "0"
      }), i.appendChild(r), document.body.appendChild(i), await new Promise((l) => requestAnimationFrame(l)), this._resolveCSSVars(r, t);
      const o = on(r), a = r.querySelector("defs"), s = a ? `<defs>${on(a)}</defs>` : "", c = (
        /** @type {SVGGraphicsElement} */
        r.getBBox()
      );
      document.body.removeChild(i);
      const u = `<?xml version="1.0" encoding="utf-8"?>
<!-- created with process-landscape -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
     width="${c.width}" height="${c.height}"
     viewBox="${c.x} ${c.y} ${c.width} ${c.height}" version="1.1">
  ${s}
  ${o}
</svg>`;
      return this._eventBus.fire("saveSVG.done", { svg: u }), { svg: u };
    } catch (t) {
      throw this._eventBus.fire("saveSVG.done", { error: t }), t;
    }
  }
}
N(ci, "$inject", ["eventBus", "canvas"]);
const df = {
  __init__: ["processLandscapeExporter"],
  processLandscapeExporter: ["type", ci]
};
function li(e) {
  this._counter = 0, this._prefix = (e ? e + "-" : "") + Math.floor(Math.random() * 1e9) + "-";
}
li.prototype.next = function() {
  return this._prefix + ++this._counter;
};
var ff = new li("ov"), pf = 500;
function P(e, t, n, r) {
  this._eventBus = t, this._canvas = n, this._elementRegistry = r, this._ids = ff, this._overlayDefaults = R({
    // no show constraints
    show: null,
    // always scale
    scale: !0
  }, e && e.defaults), this._overlays = {}, this._overlayContainers = [], this._overlayRoot = gf(n.getContainer()), this._init();
}
P.$inject = [
  "config.overlays",
  "eventBus",
  "canvas",
  "elementRegistry"
];
P.prototype.get = function(e) {
  if (xt(e) && (e = { id: e }), xt(e.element) && (e.element = this._elementRegistry.get(e.element)), e.element) {
    var t = this._getOverlayContainer(e.element, !0);
    return t ? e.type ? Ce(t.overlays, sn({ type: e.type })) : t.overlays.slice() : [];
  } else return e.type ? Ce(this._overlays, sn({ type: e.type })) : e.id ? this._overlays[e.id] : null;
};
P.prototype.add = function(e, t, n) {
  if (he(t) && (n = t, t = null), e.id || (e = this._elementRegistry.get(e)), !n.position)
    throw new Error("must specifiy overlay position");
  if (!n.html)
    throw new Error("must specifiy overlay html");
  if (!e)
    throw new Error("invalid element specified");
  var r = this._ids.next();
  return n = R({}, this._overlayDefaults, n, {
    id: r,
    type: t,
    element: e,
    html: n.html
  }), this._addOverlay(n), r;
};
P.prototype.remove = function(e) {
  var t = this.get(e) || [];
  D(t) || (t = [t]);
  var n = this;
  v(t, function(r) {
    var i = n._getOverlayContainer(r.element, !0);
    if (r && (wt(r.html), wt(r.htmlContainer), delete r.htmlContainer, delete r.element, delete n._overlays[r.id]), i) {
      var o = i.overlays.indexOf(r);
      o !== -1 && i.overlays.splice(o, 1);
    }
  });
};
P.prototype.isShown = function() {
  return this._overlayRoot.style.display !== "none";
};
P.prototype.show = function() {
  yt(this._overlayRoot);
};
P.prototype.hide = function() {
  yt(this._overlayRoot, !1);
};
P.prototype.clear = function() {
  this._overlays = {}, this._overlayContainers = [], Yn(this._overlayRoot);
};
P.prototype._updateOverlayContainer = function(e) {
  var t = e.element, n = e.html, r = t.x, i = t.y;
  if (t.waypoints) {
    var o = Te(t);
    r = o.x, i = o.y;
  }
  ui(n, r, i), Re(e.html, "data-container-id", t.id);
};
P.prototype._updateOverlay = function(e) {
  var t = e.position, n = e.htmlContainer, r = e.element, i = t.left, o = t.top;
  if (t.right !== void 0) {
    var a;
    r.waypoints ? a = Te(r).width : a = r.width, i = t.right * -1 + a;
  }
  if (t.bottom !== void 0) {
    var s;
    r.waypoints ? s = Te(r).height : s = r.height, o = t.bottom * -1 + s;
  }
  ui(n, i || 0, o || 0), this._updateOverlayVisibilty(e, this._canvas.viewbox());
};
P.prototype._createOverlayContainer = function(e) {
  var t = oe('<div class="djs-overlays" />');
  $e(t, { position: "absolute" }), this._overlayRoot.appendChild(t);
  var n = {
    html: t,
    element: e,
    overlays: []
  };
  return this._updateOverlayContainer(n), this._overlayContainers.push(n), n;
};
P.prototype._updateRoot = function(e) {
  var t = e.scale || 1, n = "matrix(" + [
    t,
    0,
    0,
    t,
    -1 * e.x * t,
    -1 * e.y * t
  ].join(",") + ")";
  hi(this._overlayRoot, n);
};
P.prototype._getOverlayContainer = function(e, t) {
  var n = Xe(this._overlayContainers, function(r) {
    return r.element === e;
  });
  return !n && !t ? this._createOverlayContainer(e) : n;
};
P.prototype._addOverlay = function(e) {
  var t = e.id, n = e.element, r = e.html, i, o;
  r.get && r.constructor.prototype.jquery && (r = r.get(0)), xt(r) && (r = oe(r)), o = this._getOverlayContainer(n), i = oe('<div class="djs-overlay" data-overlay-id="' + t + '">'), $e(i, { position: "absolute" }), i.appendChild(r), e.type && Z(i).add("djs-overlay-" + e.type);
  var a = this._canvas.findRoot(n), s = this._canvas.getRootElement();
  yt(i, a === s), e.htmlContainer = i, o.overlays.push(e), o.html.appendChild(i), this._overlays[t] = e, this._updateOverlay(e), this._updateOverlayVisibilty(e, this._canvas.viewbox());
};
P.prototype._updateOverlayVisibilty = function(e, t) {
  var n = e.show, r = this._canvas.findRoot(e.element), i = n && n.minZoom, o = n && n.maxZoom, a = e.htmlContainer, s = this._canvas.getRootElement(), c = !0;
  (r !== s || n && (W(i) && i > t.scale || W(o) && o < t.scale)) && (c = !1), yt(a, c), this._updateOverlayScale(e, t);
};
P.prototype._updateOverlayScale = function(e, t) {
  var n = e.scale, r, i, o = e.htmlContainer, a, s = "";
  n !== !0 && (n === !1 ? (r = 1, i = 1) : (r = n.min, i = n.max), W(r) && t.scale < r && (a = (1 / t.scale || 1) * r), W(i) && t.scale > i && (a = (1 / t.scale || 1) * i)), W(a) && (s = "scale(" + a + "," + a + ")"), hi(o, s);
};
P.prototype._updateOverlaysVisibilty = function(e) {
  var t = this;
  v(this._overlays, function(n) {
    t._updateOverlayVisibilty(n, e);
  });
};
P.prototype._init = function() {
  var e = this._eventBus, t = this;
  function n(r) {
    t._updateRoot(r), t._updateOverlaysVisibilty(r), t.show();
  }
  e.on("canvas.viewbox.changing", function(r) {
    t.hide();
  }), e.on("canvas.viewbox.changed", function(r) {
    n(r.viewbox);
  }), e.on(["shape.remove", "connection.remove"], function(r) {
    var i = r.element, o = t.get({ element: i });
    v(o, function(c) {
      t.remove(c.id);
    });
    var a = t._getOverlayContainer(i);
    if (a) {
      wt(a.html);
      var s = t._overlayContainers.indexOf(a);
      s !== -1 && t._overlayContainers.splice(s, 1);
    }
  }), e.on("element.changed", pf, function(r) {
    var i = r.element, o = t._getOverlayContainer(i, !0);
    o && (v(o.overlays, function(a) {
      t._updateOverlay(a);
    }), t._updateOverlayContainer(o));
  }), e.on("element.marker.update", function(r) {
    var i = t._getOverlayContainer(r.element, !0);
    i && Z(i.html)[r.add ? "add" : "remove"](r.marker);
  }), e.on("root.set", function() {
    t._updateOverlaysVisibilty(t._canvas.viewbox());
  }), e.on("diagram.clear", this.clear, this);
};
function gf(e) {
  var t = oe(
    '<div class="djs-overlay-container" />'
  );
  return $e(t, {
    position: "absolute",
    width: 0,
    height: 0
  }), e.insertBefore(t, e.firstChild), t;
}
function ui(e, t, n) {
  $e(e, { left: t + "px", top: n + "px" });
}
function yt(e, t) {
  e.style.display = t === !1 ? "none" : "";
}
function hi(e, t) {
  e.style["transform-origin"] = "top left", ["", "-ms-", "-webkit-"].forEach(function(n) {
    e.style[n + "transform"] = t;
  });
}
const yf = {
  __init__: ["overlays"],
  overlays: ["type", P]
};
function vf(e, t) {
  return t = t || {}, e.replace(/{([^}]+)}/g, function(n, r) {
    return t[r] || "{" + r + "}";
  });
}
const _f = {
  translate: ["value", vf]
};
var mf = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;"
};
function Sf(e) {
  return e = "" + e, e && e.replace(/[&<>"']/g, function(t) {
    return mf[t];
  });
}
var Ef = ["c", "C"], bf = ["v", "V"], wf = ["y", "Y"], di = ["z", "Z"];
function xf(e) {
  return e.ctrlKey || e.metaKey || e.shiftKey || e.altKey;
}
function ee(e) {
  return e.altKey ? !1 : e.ctrlKey || e.metaKey;
}
function I(e, t) {
  return e = D(e) ? e : [e], e.indexOf(t.key) !== -1 || e.indexOf(t.code) !== -1;
}
function nn(e) {
  return e.shiftKey;
}
function Cf(e) {
  return ee(e) && I(Ef, e);
}
function Tf(e) {
  return ee(e) && I(bf, e);
}
function kf(e) {
  return ee(e) && !nn(e) && I(di, e);
}
function Of(e) {
  return ee(e) && (I(wf, e) || I(di, e) && nn(e));
}
var fi = 300;
function m(e, t, n, r) {
  this._open = !1, this._results = {}, this._eventMaps = [], this._cachedRootElement = null, this._cachedSelection = null, this._cachedViewbox = null, this._canvas = e, this._eventBus = t, this._selection = n, this._translate = r, this._container = this._getBoxHtml(), this._searchInput = ie(m.INPUT_SELECTOR, this._container), this._resultsContainer = ie(m.RESULTS_CONTAINER_SELECTOR, this._container), this._canvas.getContainer().appendChild(this._container), t.on([
    "canvas.destroy",
    "diagram.destroy",
    "drag.init",
    "elements.changed"
  ], this.close, this);
}
m.$inject = [
  "canvas",
  "eventBus",
  "selection",
  "translate"
];
m.prototype._bindEvents = function() {
  var e = this;
  function t(n, r, i, o) {
    e._eventMaps.push({
      el: n,
      type: i,
      listener: We.bind(n, r, i, o)
    });
  }
  t(document, "html", "click", function(n) {
    e.close(!1);
  }), t(this._container, m.INPUT_SELECTOR, "click", function(n) {
    n.stopPropagation(), n.delegateTarget.focus();
  }), t(this._container, m.RESULT_SELECTOR, "mouseover", function(n) {
    n.stopPropagation(), e._scrollToNode(n.delegateTarget), e._preselect(n.delegateTarget);
  }), t(this._container, m.RESULT_SELECTOR, "click", function(n) {
    n.stopPropagation(), e._select(n.delegateTarget);
  }), t(this._container, m.INPUT_SELECTOR, "keydown", function(n) {
    I("ArrowUp", n) && n.preventDefault(), I("ArrowDown", n) && n.preventDefault();
  }), t(this._container, m.INPUT_SELECTOR, "keyup", function(n) {
    if (I("Escape", n))
      return e.close();
    if (I("Enter", n)) {
      var r = e._getCurrentResult();
      return r ? e._select(r) : e.close(!1);
    }
    if (I("ArrowUp", n))
      return e._scrollToDirection(!0);
    if (I("ArrowDown", n))
      return e._scrollToDirection();
    I(["ArrowLeft", "ArrowRight"], n) || e._search(n.delegateTarget.value);
  });
};
m.prototype._unbindEvents = function() {
  this._eventMaps.forEach(function(e) {
    We.unbind(e.el, e.type, e.listener);
  });
};
m.prototype._search = function(e) {
  var t = this;
  if (this._clearResults(), !!e.trim()) {
    var n = this._searchProvider.find(e);
    if (n = n.filter(function(i) {
      return !t._canvas.getRootElements().includes(i.element);
    }), !n.length) {
      this._selection.select(null);
      return;
    }
    n.forEach(function(i) {
      var o = i.element.id, a = t._createResultNode(i, o);
      t._results[o] = {
        element: i.element,
        node: a
      };
    });
    var r = ie(m.RESULT_SELECTOR, this._resultsContainer);
    this._scrollToNode(r), this._preselect(r);
  }
};
m.prototype._scrollToDirection = function(e) {
  var t = this._getCurrentResult();
  if (t) {
    var n = e ? t.previousElementSibling : t.nextElementSibling;
    n && (this._scrollToNode(n), this._preselect(n));
  }
};
m.prototype._scrollToNode = function(e) {
  if (!(!e || e === this._getCurrentResult())) {
    var t = e.offsetTop, n = this._resultsContainer.scrollTop, r = t - this._resultsContainer.clientHeight + e.clientHeight;
    t < n ? this._resultsContainer.scrollTop = t : n < r && (this._resultsContainer.scrollTop = r);
  }
};
m.prototype._clearResults = function() {
  Yn(this._resultsContainer), this._results = {}, this._eventBus.fire("searchPad.cleared");
};
m.prototype._getCurrentResult = function() {
  return ie(m.RESULT_SELECTED_SELECTOR, this._resultsContainer);
};
m.prototype._createResultNode = function(e, t) {
  var n = oe(m.RESULT_HTML);
  return e.primaryTokens.length > 0 && Vn(n, e.primaryTokens, m.RESULT_PRIMARY_HTML), Vn(n, e.secondaryTokens, m.RESULT_SECONDARY_HTML), Re(n, m.RESULT_ID_ATTRIBUTE, t), this._resultsContainer.appendChild(n), n;
};
m.prototype.registerProvider = function(e) {
  this._searchProvider = e;
};
m.prototype.open = function() {
  if (!this._searchProvider)
    throw new Error("no search provider registered");
  this.isOpen() || (this._cachedRootElement = this._canvas.getRootElement(), this._cachedSelection = this._selection.get(), this._cachedViewbox = this._canvas.viewbox(), this._selection.select(null), this._bindEvents(), this._open = !0, Z(this._canvas.getContainer()).add("djs-search-open"), Z(this._container).add("open"), this._searchInput.focus(), this._eventBus.fire("searchPad.opened"));
};
m.prototype.close = function(e = !0) {
  this.isOpen() && (e && (this._cachedRootElement && this._canvas.setRootElement(this._cachedRootElement), this._cachedSelection && this._selection.select(this._cachedSelection), this._cachedViewbox && this._canvas.viewbox(this._cachedViewbox), this._eventBus.fire("searchPad.restored")), this._cachedRootElement = null, this._cachedSelection = null, this._cachedViewbox = null, this._unbindEvents(), this._open = !1, Z(this._canvas.getContainer()).remove("djs-search-open"), Z(this._container).remove("open"), this._clearResults(), this._searchInput.value = "", this._searchInput.blur(), this._eventBus.fire("searchPad.closed"), this._canvas.restoreFocus());
};
m.prototype.toggle = function() {
  this.isOpen() ? this.close() : this.open();
};
m.prototype.isOpen = function() {
  return this._open;
};
m.prototype._preselect = function(e) {
  var t = this._getCurrentResult();
  if (e !== t) {
    t && Z(t).remove(m.RESULT_SELECTED_CLASS);
    var n = Re(e, m.RESULT_ID_ATTRIBUTE), r = this._results[n].element;
    Z(e).add(m.RESULT_SELECTED_CLASS), this._canvas.scrollToElement(r, {
      top: fi
    }), this._selection.select(r), this._eventBus.fire("searchPad.preselected", r);
  }
};
m.prototype._select = function(e) {
  var t = Re(e, m.RESULT_ID_ATTRIBUTE), n = this._results[t].element;
  this._cachedSelection = null, this._cachedViewbox = null, this.close(!1), this._canvas.scrollToElement(n, {
    top: fi
  }), this._selection.select(n), this._eventBus.fire("searchPad.selected", n);
};
m.prototype._getBoxHtml = function() {
  const e = oe(m.BOX_HTML), t = ie(m.INPUT_SELECTOR, e);
  return t && t.setAttribute("aria-label", this._translate("Search in diagram")), e;
};
function Vn(e, t, n) {
  var r = Rf(t), i = oe(n);
  i.innerHTML = r, e.appendChild(i);
}
function Rf(e) {
  var t = "";
  return e.forEach(function(n) {
    var r = Sf(n.value || n.matched || n.normal), i = n.match || n.matched;
    i ? t += '<b class="' + m.RESULT_HIGHLIGHT_CLASS + '">' + r + "</b>" : t += r;
  }), t !== "" ? t : null;
}
m.CONTAINER_SELECTOR = ".djs-search-container";
m.INPUT_SELECTOR = ".djs-search-input input";
m.RESULTS_CONTAINER_SELECTOR = ".djs-search-results";
m.RESULT_SELECTOR = ".djs-search-result";
m.RESULT_SELECTED_CLASS = "djs-search-result-selected";
m.RESULT_SELECTED_SELECTOR = "." + m.RESULT_SELECTED_CLASS;
m.RESULT_ID_ATTRIBUTE = "data-result-id";
m.RESULT_HIGHLIGHT_CLASS = "djs-search-highlight";
m.BOX_HTML = `<div class="djs-search-container djs-scrollable">
  <div class="djs-search-input">
    <svg class="djs-search-icon" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M9.0325 8.5H9.625L13.3675 12.25L12.25 13.3675L8.5 9.625V9.0325L8.2975 8.8225C7.4425 9.5575 6.3325 10 5.125 10C2.4325 10 0.25 7.8175 0.25 5.125C0.25 2.4325 2.4325 0.25 5.125 0.25C7.8175 0.25 10 2.4325 10 5.125C10 6.3325 9.5575 7.4425 8.8225 8.2975L9.0325 8.5ZM1.75 5.125C1.75 6.9925 3.2575 8.5 5.125 8.5C6.9925 8.5 8.5 6.9925 8.5 5.125C8.5 3.2575 6.9925 1.75 5.125 1.75C3.2575 1.75 1.75 3.2575 1.75 5.125Z" fill="#22242A"/>
    </svg>
    <input type="text" spellcheck="false" />
  </div>
  <div class="djs-search-results" />
</div>`;
m.RESULT_HTML = '<div class="djs-search-result"></div>';
m.RESULT_PRIMARY_HTML = '<div class="djs-search-result-primary"></div>';
m.RESULT_SECONDARY_HTML = '<p class="djs-search-result-secondary"></p>';
const $f = {
  __depends__: [
    _f,
    yf,
    jt
  ],
  searchPad: ["type", m]
};
function Lf(e, t, n) {
  const {
    keys: r
  } = n;
  if (t = t.trim().toLowerCase(), !t)
    throw new Error("<pattern> must not be empty");
  const i = t.trim().toLowerCase().split(/\s+/);
  return e.flatMap((o) => {
    const a = Af(o, i, r);
    return a ? {
      item: o,
      tokens: a
    } : [];
  }).sort(Mf(r));
}
function Af(e, t, n) {
  const {
    matchedWords: r,
    tokens: i
  } = n.reduce((o, a) => {
    const s = e[a], {
      tokens: c,
      matchedWords: u
    } = Hf(s, t);
    return {
      tokens: {
        ...o.tokens,
        [a]: c
      },
      matchedWords: {
        ...o.matchedWords,
        ...u
      }
    };
  }, {
    matchedWords: {},
    tokens: {}
  });
  return Object.keys(r).length !== t.length ? null : i;
}
function Mf(e) {
  return (t, n) => {
    for (const r of e) {
      const i = Pf(
        t.tokens[r],
        n.tokens[r]
      );
      if (i !== 0)
        return i;
      const o = If(
        t.item[r],
        n.item[r]
      );
      if (o !== 0)
        return o;
    }
    return 0;
  };
}
function Pf(e, t) {
  return Wn(t) - Wn(e);
}
function Wn(e) {
  return e.reduce((t, n) => t + jf(n), 0);
}
function jf(e) {
  const t = Math.log(e.value.length);
  return e.match ? (e.start ? e.end ? 131.9 : 7.87 : e.wordStart ? 2.19 : 1) * t : -0.07 * t;
}
function If(e = "", t = "") {
  return e.localeCompare(t);
}
function Hf(e, t) {
  if (!e)
    return {
      tokens: [],
      matchedWords: {}
    };
  const n = [], r = {}, i = t.map(Nf), o = [
    `(?<all>${i.join("\\s+")})`,
    ...i
  ].join("|"), a = new RegExp(o, "ig");
  let s, c = 0;
  for (; s = a.exec(e); ) {
    const [u] = s, l = s.index, h = s.index + u.length, d = l === 0, S = h === e.length, p = !!s.groups.all, b = d || /\s/.test(e.charAt(l - 1)), y = S || /\s/.test(e.charAt(h + 1));
    s.index > c && n.push({
      value: e.slice(c, s.index),
      index: c
    }), n.push({
      value: u,
      index: s.index,
      match: !0,
      wordStart: b,
      wordEnd: y,
      start: d,
      end: S,
      all: p
    });
    const T = p ? t : [u];
    for (const w of T)
      r[w.toLowerCase()] = !0;
    c = s.index + u.length;
  }
  return c < e.length && n.push({
    value: e.slice(c),
    index: c
  }), {
    tokens: n,
    matchedWords: r
  };
}
function Nf(e) {
  return e.replace(/[/\-\\^$*+?.()|[\]{}]/g, "\\$&");
}
const Df = {
  search: ["value", Lf]
};
class pi {
  /**
   * @param {ElementRegistry} elementRegistry
   * @param {SearchPad} searchPad
   * @param {Canvas} canvas
   * @param {Search} search
   */
  constructor(t, n, r, i) {
    this._elementRegistry = t, this._canvas = r, this._search = i, n.registerProvider(this);
  }
  /**
   * Searches for elements matching the given pattern.
   *
   * @param {string} pattern
   * @return {SearchPadResult[]}
   */
  find(t) {
    const n = this._elementRegistry.filter((r) => {
      var i;
      return (i = r.businessObject) == null ? void 0 : i.searchable;
    }).map((r) => ({
      element: r,
      name: r.name,
      id: r.businessObject.data.sourceId
    }));
    return this._search(n, t, {
      keys: ["name", "id"]
    }).map(Bf);
  }
}
N(pi, "$inject", ["elementRegistry", "searchPad", "canvas", "search"]);
function Bf(e) {
  const {
    item: { element: t },
    tokens: n
  } = e;
  return {
    element: t,
    primaryTokens: n.name,
    secondaryTokens: n.id
  };
}
const Ff = {
  __depends__: [$f, Df],
  __init__: ["processLandscapeSearch"],
  processLandscapeSearch: ["type", pi]
};
var vt = "keyboard.keydown", Uf = "keyboard.keyup", zf = 1e3, gi = "Keyboard binding is now implicit; explicit binding to an element got removed. For more information, see https://github.com/bpmn-io/diagram-js/issues/661";
function H(e, t) {
  var n = this;
  this._config = e = e || {}, this._eventBus = t, this._keydownHandler = this._keydownHandler.bind(this), this._keyupHandler = this._keyupHandler.bind(this), t.on("diagram.destroy", function() {
    n._fire("destroy"), n.unbind();
  }), e.bindTo && console.error("unsupported configuration <keyboard.bindTo>", new Error(gi));
  var r = e && e.bind !== !1;
  t.on("canvas.init", function(i) {
    n._target = i.svg, r && n.bind(), n._fire("init");
  });
}
H.$inject = [
  "config.keyboard",
  "eventBus"
];
H.prototype._keydownHandler = function(e) {
  this._keyHandler(e, vt);
};
H.prototype._keyupHandler = function(e) {
  this._keyHandler(e, Uf);
};
H.prototype._keyHandler = function(e, t) {
  var n;
  if (!this._isEventIgnored(e)) {
    var r = {
      keyEvent: e
    };
    n = this._eventBus.fire(t || vt, r), n && e.preventDefault();
  }
};
H.prototype._isEventIgnored = function(e) {
  return !1;
};
H.prototype.bind = function(e) {
  e && console.error("unsupported argument <node>", new Error(gi)), this.unbind(), e = this._node = this._target, q.bind(e, "keydown", this._keydownHandler), q.bind(e, "keyup", this._keyupHandler), this._fire("bind");
};
H.prototype.getBinding = function() {
  return this._node;
};
H.prototype.unbind = function() {
  var e = this._node;
  e && (this._fire("unbind"), q.unbind(e, "keydown", this._keydownHandler), q.unbind(e, "keyup", this._keyupHandler)), this._node = null;
};
H.prototype._fire = function(e) {
  this._eventBus.fire("keyboard." + e, { node: this._node });
};
H.prototype.addListener = function(e, t, n) {
  At(e) && (n = t, t = e, e = zf), this._eventBus.on(n || vt, e, t);
};
H.prototype.removeListener = function(e, t) {
  this._eventBus.off(t || vt, e);
};
H.prototype.hasModifier = xf;
H.prototype.isCmd = ee;
H.prototype.isShift = nn;
H.prototype.isKey = I;
var Gf = 500;
function _t(e, t) {
  var n = this;
  e.on("editorActions.init", Gf, function(r) {
    var i = r.editorActions;
    n.registerBindings(t, i);
  });
}
_t.$inject = [
  "eventBus",
  "keyboard"
];
_t.prototype.registerBindings = function(e, t) {
  function n(r, i) {
    t.isRegistered(r) && e.addListener(i);
  }
  n("undo", function(r) {
    var i = r.keyEvent;
    if (kf(i))
      return t.trigger("undo"), !0;
  }), n("redo", function(r) {
    var i = r.keyEvent;
    if (Of(i))
      return t.trigger("redo"), !0;
  }), n("copy", function(r) {
    var i = r.keyEvent;
    if (Cf(i))
      return t.trigger("copy"), !0;
  }), n("paste", function(r) {
    var i = r.keyEvent;
    if (Tf(i))
      return t.trigger("paste"), !0;
  }), n("stepZoom", function(r) {
    var i = r.keyEvent;
    if (I(["+", "Add", "="], i) && ee(i))
      return t.trigger("stepZoom", { value: 1 }), !0;
  }), n("stepZoom", function(r) {
    var i = r.keyEvent;
    if (I(["-", "Subtract"], i) && ee(i))
      return t.trigger("stepZoom", { value: -1 }), !0;
  }), n("zoom", function(r) {
    var i = r.keyEvent;
    if (I("0", i) && ee(i))
      return t.trigger("zoom", { value: 1 }), !0;
  }), n("removeSelection", function(r) {
    var i = r.keyEvent;
    if (I(["Backspace", "Delete", "Del"], i))
      return t.trigger("removeSelection"), !0;
  });
};
const Vf = {
  __init__: ["keyboard", "keyboardBindings"],
  keyboard: ["type", H],
  keyboardBindings: ["type", _t]
};
class yi extends _t {
  /**
   * @param {EventBus} eventBus
   * @param {Keyboard} keyboard
   */
  constructor(t, n) {
    super(t, n);
  }
  /**
   * Register available keyboard bindings.
   *
   * @param {Keyboard} keyboard
   * @param {EditorActions} editorActions
   */
  registerBindings(t, n) {
    super.registerBindings(t, n), ((i, o) => {
      n.isRegistered(i) && t.addListener(o);
    })("find", (i) => {
      const o = i.keyEvent;
      return t.isKey(["f", "F"], o) && t.isCmd(o) ? (n.trigger("find"), !0) : !1;
    });
  }
}
N(yi, "$inject", ["eventBus", "keyboard"]);
const Wf = {
  __depends__: [Vf],
  __init__: ["keyboardBindings"],
  keyboardBindings: ["type", yi]
};
var vi = "is not a registered action", Kf = "is already registered";
function Y(e, t) {
  this._actions = {};
  var n = this;
  e.on("diagram.init", function() {
    n._registerDefaultActions(t), e.fire("editorActions.init", {
      editorActions: n
    });
  });
}
Y.$inject = [
  "eventBus",
  "injector"
];
Y.prototype._registerDefaultActions = function(e) {
  var t = e.get("commandStack", !1), n = e.get("modeling", !1), r = e.get("selection", !1), i = e.get("zoomScroll", !1), o = e.get("copyPaste", !1), a = e.get("canvas", !1), s = e.get("rules", !1), c = e.get("keyboardMove", !1), u = e.get("keyboardMoveSelection", !1);
  t && (this.register("undo", function() {
    t.undo();
  }), this.register("redo", function() {
    t.redo();
  })), o && r && this.register("copy", function() {
    var l = r.get();
    if (l.length)
      return o.copy(l);
  }), o && this.register("paste", function() {
    o.paste();
  }), i && this.register("stepZoom", function(l) {
    i.stepZoom(l.value);
  }), a && this.register("zoom", function(l) {
    a.zoom(l.value);
  }), n && r && s && this.register("removeSelection", function() {
    var l = r.get();
    if (l.length) {
      var h = s.allowed("elements.delete", { elements: l }), d;
      h !== !1 && (D(h) ? d = h : d = l, d.length && n.removeElements(d.slice()));
    }
  }), c && this.register("moveCanvas", function(l) {
    c.moveCanvas(l);
  }), u && this.register("moveSelection", function(l) {
    u.moveSelection(l.direction, l.accelerated);
  });
};
Y.prototype.trigger = function(e, t) {
  if (!this._actions[e])
    throw rn(e, vi);
  return this._actions[e](t);
};
Y.prototype.register = function(e, t) {
  var n = this;
  if (typeof e == "string")
    return this._registerAction(e, t);
  v(e, function(r, i) {
    n._registerAction(i, r);
  });
};
Y.prototype._registerAction = function(e, t) {
  if (this.isRegistered(e))
    throw rn(e, Kf);
  this._actions[e] = t;
};
Y.prototype.unregister = function(e) {
  if (!this.isRegistered(e))
    throw rn(e, vi);
  this._actions[e] = void 0;
};
Y.prototype.getActions = function() {
  return Object.keys(this._actions);
};
Y.prototype.isRegistered = function(e) {
  return !!this._actions[e];
};
function rn(e, t) {
  return new Error(e + " " + t);
}
const Yf = {
  __init__: ["editorActions"],
  editorActions: ["type", Y]
};
class _i extends Y {
  /**
   * @param {EventBus} eventBus
   * @param {Injector} injector
   */
  constructor(t, n) {
    super(t, n), this._injector = n, this._registerDefaultProcessLandscapeActions();
  }
  _registerDefaultProcessLandscapeActions() {
    const t = this._injector.get("searchPad", !1);
    t && super.register("find", () => {
      t.toggle();
    });
  }
}
N(_i, "$inject", ["eventBus", "injector"]);
const qf = {
  __depends__: [Yf],
  editorActions: ["type", _i]
}, bt = "pls-container";
class ap {
  /**
   * Initializes a new instance of ProcessLandscape.
   *
   * @constructor
   * @param {Object} options - Configuration options for initializing the ProcessLandscape.
   * @param {HTMLElement} options.root - The root HTML element where the diagram is mounted.
   * @param {Object} [options.data] - Initial landscape data to import into the diagram.
   * @param {Array} [options.additionalModules=[]] - Additional modules to extend diagram functionality.
   * @param {Object} [options.canvas] - Configuration options for the diagram's canvas.
   * @param {Object} [options.restConfig] - Additional configuration options to pass to the diagram
   */
  constructor(t) {
    const {
      root: n,
      data: r,
      additionalModules: i = [],
      canvas: o = {},
      ...a
    } = t, s = [
      So,
      ko,
      Ao,
      jt,
      qf,
      Wf,
      Ff,
      cf,
      uf,
      hf,
      df
    ];
    this._root = n, this._root.classList.contains(bt) || (this._root.classList.add(bt), this._shouldClearRootClass = !0), this._diagram = new Ei({
      canvas: {
        ...o,
        container: n
      },
      modules: [...s, ...i],
      ...a
    }), this._eventBus = this._diagram.get("eventBus"), this._landscapeManager = this._diagram.get("landscapeManager"), this.clear = this._diagram.clear.bind(this._diagram), this.destroy = () => {
      this._shouldClearRootClass && this._root.classList.remove(bt), this._diagram.destroy.bind(this._diagram);
    }, this.get = this._diagram.get.bind(this._diagram), this.on = this._eventBus.on.bind(this._eventBus), this.off = this._eventBus.off.bind(this._eventBus), this.import = this._landscapeManager.import.bind(this._landscapeManager), r && this.import(r);
  }
}
const Zf = "#0043ce", Kn = "#C6C6C6", Xf = "#859fd6", Jf = "#4a5b80", Qf = "#e8e8e8", sp = () => ({
  rules: [
    C.forLandscape().apply({
      primaryNode: j.PROCESS,
      horizontalNodeSpacing: 360,
      verticalNodeSpacing: 200
    }),
    C.forNodes().applyStyles({
      rx: 3,
      ry: 3,
      stroke: Kn,
      strokeWidth: 2,
      width: 300,
      height: 85
    }),
    C.forNodes({ type: j.SUBPROCESS }).applyStyles({
      strokeDasharray: null
    }),
    C.forNodes({ type: j.REF }).applyStyles({
      stroke: "none",
      fill: Qf,
      height: 50
    }),
    C.forNodes({ type: j.FEEL }).applyStyles({
      stroke: Xf
    }),
    C.forNodes({
      type: [j.PROCESS, j.SUBPROCESS]
    }).applyAdorners({
      getAdornerInfo: (e) => {
        var t, n;
        return {
          content: (n = (t = e.businessObject) == null ? void 0 : t.externalData) == null ? void 0 : n.version,
          position: "bottom-left",
          offset: 10,
          styles: {
            fontSize: "16px",
            fill: "gray"
          }
        };
      }
    }),
    C.forLinks().applyStyles({
      stroke: Kn,
      strokeWidth: 2
    }),
    C.forLinks({ type: z.REF }).apply({
      curveSag: 0.4,
      curveShift: 0.1,
      styles: {
        stroke: "transparent",
        strokeDasharray: [5, 5]
      }
    }),
    C.forLabels().applyStyles({
      align: "left",
      padding: 15,
      fontSize: 18
    }),
    C.forLabels({ parentType: j.FEEL }).applyStyles({
      fill: Jf
    }),
    C.forAdorners().apply({ gap: 15 }),
    C.for({ state: "selected" }).applyStyles({
      stroke: Zf,
      strokeWidth: 2
    })
  ]
});
export {
  op as BPMN_TYPES,
  Mo as DJSE_TYPES,
  $t as LABEL_TYPES,
  ke as LINK_DRAWING_TYPES,
  z as LINK_TYPES,
  j as NODE_TYPES,
  ap as ProcessLandscape,
  C as RuleBuilder,
  sp as basicWebModelerConfig
};
//# sourceMappingURL=index.js.map
